import { environment } from '../../../../../environments/environment';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { InvoicesService } from 'src/app/dashboard/preview/invoices/services/invoices.service';
import { TemplateService } from 'src/app/dashboard/preview/invoices/services/template.service';
import { TemplateService as TemplateService2 } from 'src/app/dashboard/preview/services/template.service';
import { ChartOfAccountsDataService, ChartOfAccountsModel } from 'src/app/dashboard/preview/sifrarnik/services/chart-of-accounts-data.service';
import { KontoMappingService, SchemaMappingService } from 'src/app/dashboard/preview/sifrarnik/services/konto-mapping.service';
import { AccountSchemaDataService, AccountSchemaModel } from 'src/app/dashboard/preview/sifrarnik/services/account-schema-data.service';
import { CodebookLookupService, CodebookItem } from 'src/app/dashboard/preview/sifrarnik/services/codebook-lookup.service';
import { OrganizationalUnitDataService, OrganizationalUnitModel } from 'src/app/dashboard/preview/sifrarnik/services/organizational-unit-data.service';
import { PriceListDataService } from 'src/app/dashboard/preview/sifrarnik/services/price-list-data.service';
import { PriceListLookupService } from 'src/app/dashboard/preview/sifrarnik/services/price-list-lookup.service';
import { localImages } from '../../../constants/app-config';
import { FolderService } from '../../../preview/invoices/services/folder.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ClientService } from '../../../preview/invoices/services/client.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TemplateModel } from 'src/app/dashboard/preview/models/template.model';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ZoomImageWheelService } from '@zoom-image/angular';
import { ZoomImageWheelState } from '@zoom-image/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { APIService, InvoiceUserAssignment } from 'src/app/API.service';
import { Storage } from 'aws-amplify';
import {
  BANK_STATEMENT_COLUMN_FIELDS,
  BANK_STATEMENT_FIELD_LABELS,
  BANK_STATEMENT_XML_FALLBACK_ATTRS,
  BANK_STATEMENT_XML_FIELDS,
  isBankStatementField,
} from '../../../constants/bank-statement-fields';
import {
  BankStatementXml,
  BankStatementXmlPatch,
  BankStatementXmlService,
} from 'src/app/dashboard/preview/invoices/services/bank-statement-xml.service';
import {
  BankPostingRule,
  BankPostingRuleService,
  BankStatementRowValues,
} from 'src/app/dashboard/preview/invoices/services/bank-posting-rule.service';
import {
  BankPostingRuleDialogComponent,
  BankPostingRuleDialogData,
} from 'src/app/dashboard/preview/dialogs/bank-posting-rule-dialog/bank-posting-rule-dialog.component';
import {
  BankPostingRulesListDialogComponent,
  BankPostingRulesListDialogData,
} from 'src/app/dashboard/preview/dialogs/bank-posting-rules-list-dialog/bank-posting-rules-list-dialog.component';

@Component({
  selector: 'app-template-run-dialog',
  templateUrl: './template-run-dialog.component.html',
  styleUrls: ['./template-run-dialog.component.css'],
  animations: [
    trigger('rotatedState', [
      state('0', style({ transform: 'rotate(0deg)' })),
      state('90', style({ transform: 'rotate(90deg)' })),
      state('180', style({ transform: 'rotate(180deg)' })),
      state('270', style({ transform: 'rotate(270deg)' })),
      transition('* => *', [animate('{{duration}} ease-in')], {
        params: { duration: '0ms' },
      }),
    ]),
  ],
})
export class TemplateRunDialogComponent {
  templates: any = [];
  template: any = null;
  folder: any;
  fullTemplate: any = null;
  loading: boolean = false;
  isVatMissing: boolean = false;
  isTaxBaseMissing: boolean = false;
  isClosed = false;
  isPreviewTemplate = false;
  isPreviewGoodsAndMaterial = false;
  tableHeaders: any[] = [];
  tableHeadersWithoutGoodsAndMaterial: any[] = [];
  tableRowContent: any[] = [];
  filterStatusPrivatUser: boolean = true;
  vatIncludedCheckbox: any = {};
  isAllChecked = true;
  isDownloadPreview = false;
  imageIndex = 0;
  localImages = localImages;
  rowMappedTaxBaseAndVatValues: any;
  selectedInvoiceCopy: any = [];
  isLoading = false;
  startingIndex: number | undefined;
  documentIndexValue: any = {};
  isTemplateLoading = false;
  nextToken = '';
  nextTokenTemplates: any = '';
  folderID: string = '';
  selectedTemplate: any = '';
  fullTemplates: any[] = [];
  isTemplatesEmpty: boolean = false;
  isLoadingButton: boolean = false;
  listOfAllInvoicesIDs: string[] = [];
  currentInvoice: any | null;
  initialExtractedProductsResults: any;
  selectedTemplateFormat: 'excel' | 'xml' | 'txt' = 'excel';
  txtInvoicesList: any[] = [];
  selectedTxtMap: { [id: string]: boolean } = {};
  isTxtInvoicesLoading: boolean = false;
  xmlInvoicesList: any[] = [];
  selectedXmlMap: { [id: string]: boolean } = {};
  isXmlInvoicesLoading: boolean = false;
  fixedValues: any = {};
  isFixedValueEnabled: any = {};
  xmlTemplate = {
    id: 'eLine',
    _name: 'eLine',
    _description: 'XML template for eLine format',
    additionalFields: [],
    productsEnabled: true,
    template: { "documentIndex": "zagid", "skladiste": "1", "invoiceDate": "datumdokumenta", "invoiceNumber": "brojdokumenta", "obracunskajedinica": "0000", "vrstadokumenta": "21", "podvd": "0", "kupac": "74", "code": "primalac", "ID": "ID broj", "vatID": "PDV broj", "dueDate": "dpo", "bf": "", "rf": "", "nacinplacanja": "1", "total": "uplata", "oznaka": "FR", "number": "staid", "productCode": "sifra 1", "barcode": "sifra 2", "productName": "sifra 3", "quantity": "izlaz", "priceWithoutTax": "vpc", "retailPrice": "mpc", "tarifa": "K", "discountPercentage": "popustpos" },
    fixedValues: {}, // Add this
    isFixedValueEnabled: {} // Add this
  };

  readonly rows = [
    ['King Arthur', '-', 'Arrested'],
    ['Sir Bedevere', 'The Wise', 'Arrested'],
    ['Sir Lancelot', 'The Brave', 'Arrested'],
    ['Sir Galahad', 'The Chaste', 'Killed'],
    ['Sir Robin', 'The Not-Quite-So-Brave-As-Sir-Lancelot', 'Killed'],
  ];

  goodsAndMaterialFields: string[] = [
    'productCode',
    'barcode',
    'number',
    'productName',
    'unit',
    'quantity',
    'priceWithTax',
    'priceWithoutTax',
    'discountPercentage',
    'discountAmount',
    'taxPercentage',
    'taxAmount',
    'articleCode',
    'retailPrice',
    'totalPrice',
    'totalPriceWithoutTax',
    'totalPriceWithoutTaxBeforeDiscount',

    'documentDescription',
    'viaBankAccount',
    'inGoodsMaterials',
    'grossEmployeeWages',
    'paidEntrepreneurContributions',
    'otherExpenses',

    // Bank statement (izvod) row fields, read from the IZ/PR XML
    ...BANK_STATEMENT_COLUMN_FIELDS,
  ];

  // ─── Bank statement (izvod) rows ───────────────────────────────────────────
  // The IZ/PR XML of the statement currently open in the Goods & Material
  // preview. Source of Opis_1/Opis_2/Svrha/Duguje/Potrazuje and of the company
  // bank account (RACUN) the posting rules are scoped to.
  bankXml: BankStatementXml | null = null;
  bankRules: BankPostingRule[] = [];
  bankXmlLoading = false;
  /** Template whose configured titles name the XML attributes on download. */
  xmlAttributeTemplateId: string = '';

  taxBaseValues: Array<string> | undefined;
  vatValues: Array<string> | undefined;
  @ViewChild('tableRef') tableRef: ElementRef;

  ngAfterViewInit() {
    // Access the tableRef element in ngAfterViewInit
    const table = this.tableRef?.nativeElement;

    // Attach the scroll event listener to the table element
    table?.addEventListener('scroll', this.onScrollSimple);
  }

  @HostListener('window:keydown.tab', ['$event'])
  onKeyDownTab(event: KeyboardEvent): void {
    if (!this.isDownloadPreview) {
      event.preventDefault();
    }
  }

  private vatFields = [
    'deductibleVAT',
    'nonDeductibleVAT',
    'deductibleTaxBase',
    'nonDeductibleTaxBase',
  ];

  private vatSubstitutes: { [key: string]: any } = {
    deductibleVAT: 'nonDeductibleVAT',
    nonDeductibleVAT: 'deductibleVAT',
    deductibleTaxBase: 'nonDeductibleTaxBase',
    nonDeductibleTaxBase: 'deductibleTaxBase',
  };

  @ViewChild('checkboxRef') checkboxRef!: ElementRef;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  imageSrc: string = '';
  textBlocks: any[] = [];
  originalTextBlocks: any[] = [];
  selectedTextBlock: any = null;

  @ViewChild('outlet', { read: ViewContainerRef }) outletRef!: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef }) contentRef!: TemplateRef<any>;
  @ViewChild('imageElement') imageElement!: ElementRef<HTMLImageElement>;

  @ViewChild('imageWheelContainer')
  imageWheelContainerRef!: ElementRef<HTMLDivElement>;

  zoomImageWheelState: ZoomImageWheelState | null = null;
  overlayTransform: string = '';
  transformOrigin: string = 'top left';
  displayedImageWidth = 0;
  displayedImageHeight = 0;

  // TXT file preview support
  txtFileContent: string = '';
  txtFileLoading: boolean = false;
  txtContentCache: { [key: string]: string } = {};
  rowUseCash: { [key: number]: boolean } = {};
  rowSyncToEPO: { [key: number]: boolean } = {};
  /** Konto / partner cells the user set by hand; rules never overwrite these. */
  rowBankManualKonto: { [key: number]: boolean } = {};
  rowBankManualPartner: { [key: number]: boolean } = {};

  chartOfAccounts: ChartOfAccountsModel[] = [];
  filteredChartOfAccounts: ChartOfAccountsModel[] = [];
  private kontoLabelMap: { [konto: string]: string } = {};
  // Account schemas back the `schema` template field exactly like the chart
  // of accounts backs `konto`.
  accountSchemas: AccountSchemaModel[] = [];
  private schemaLabelMap: { [schema: string]: string } = {};
  organizationalUnits: OrganizationalUnitModel[] = [];
  filteredOrganizationalUnits: OrganizationalUnitModel[] = [];
  private organizationalUnitLabelMap: { [code: string]: string } = {};
  private codebookItems: CodebookItem[] = [];
  private codebookLabelMap: { [code: string]: string } = {};
  // Article code label map so the dropdown and display function are O(1).
  private articleCodeLabelMap: { [code: string]: string } = {};
  // Guards against re-fetching a price list of tens of thousands of rows every
  // time the goods and material preview is opened.
  private priceListLoading: Promise<void> | null = null;

  constructor(
    private invoiceService: InvoicesService,
    private templateService: TemplateService,
    private templateService2: TemplateService2,
    private folderService: FolderService,
    public dialogRef: MatDialogRef<TemplateRunDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private clientService: ClientService,
    private snackBar: MatSnackBar,
    private renderer: Renderer2,
    private http: HttpClient,
    private zoomImageWheelService: ZoomImageWheelService,
    private invoicesService: InvoicesService,
    private apiService: APIService,
    private coaDataService: ChartOfAccountsDataService,
    private kontoMappingService: KontoMappingService,
    private schemaDataService: AccountSchemaDataService,
    private schemaMappingService: SchemaMappingService,
    private ouDataService: OrganizationalUnitDataService,
    private codebookLookupService: CodebookLookupService,
    private priceListDataService: PriceListDataService,
    private priceListLookupService: PriceListLookupService,
    private bankXmlService: BankStatementXmlService,
    private bankRuleService: BankPostingRuleService,
    private dialog: MatDialog
  ) {
    this.tableRef = new ElementRef(null);
    if (this.data) {
      this.folder = this.data.folder;
    }
    if (this.data.duplicatedArray) {
      this.folderID = this.data.duplicatedArray[0].folderID;
      this.data.duplicatedArray = [];
    }
  }

  onImageLoad() {
    console.log('🖼️ Image loaded, initializing zoom and bounding boxes...');

    if (!this.outletRef || !this.contentRef) {
      console.error('❌ ViewChild references are missing.');
      return;
    }

    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);

    setTimeout(() => {
      console.log('✅ Reassigning ViewChild references...');

      const imageEl = document.querySelector(
        '.uploaded-image'
      ) as HTMLImageElement | null;
      const containerEl = document.querySelector(
        '.image-container'
      ) as HTMLDivElement | null;

      if (!imageEl || !containerEl) {
        console.error(
          '❌ ViewChild references are still missing after rerender.'
        );
        return;
      }

      (this.imageElement as any) = new ElementRef(imageEl);
      (this.imageWheelContainerRef as any) = new ElementRef(containerEl);

      if (
        !this.imageElement?.nativeElement ||
        !this.imageWheelContainerRef?.nativeElement
      ) {
        console.error('❌ ViewChild references are not available.');
        return;
      }

      const imgEl = this.imageElement.nativeElement;
      this.displayedImageWidth = imgEl.clientWidth;
      this.displayedImageHeight = imgEl.clientHeight;

      if (this.zoomImageWheelState) {
        console.log('🛑 Destroying previous zoom instance...');
        this.zoomImageWheelService.setZoomImageState({ currentZoom: 1 });
        this.zoomImageWheelState = null;
      }

      setTimeout(() => {
        console.log('🚀 Initializing zoom for new image...');
        this.zoomImageWheelService.createZoomImage(
          this.imageWheelContainerRef.nativeElement
        );
      }, 100);

      const currentInvoice = this.data.duplicatedArray?.[this.imageIndex];
      if (!currentInvoice) {
        console.error('❌ Invoice data is missing.');
        return;
      }

      const textractUrl = `https://${environment.s3BucketName}.s3.eu-central-1.amazonaws.com/public/invoiceLabels/${currentInvoice.id}.json`;

      console.log('📥 Fetching Textract data from:', textractUrl);

      this.fetchTextractData(textractUrl);

      this.zoomImageWheelService.zoomImageState$.subscribe((state) => {
        this.zoomImageWheelState = state;

        const {
          currentZoom,
          currentPositionX,
          currentPositionY,
          currentRotation,
        } = state;

        this.overlayTransform = `
        translate(${currentPositionX}px, ${currentPositionY}px)
        scale(${currentZoom})
        rotate(${currentRotation}deg)
      `;
      });
    }, 100);
  }

  onGoodsAndMaterialsImageLoad() {
    // Use the centralized zoom initialization
    this.initGoodsAndMaterialsZoom();
  }

  async fetchTextractData(url: string) {
    this.http.get<any>(url).subscribe(
      (response) => {
        console.log('✅ Textract Data:', response);

        this.originalTextBlocks = response.Blocks.filter(
          (block: any) =>
            block.BlockType === 'LINE' || block.BlockType === 'WORD'
        );

        this.scaleBoundingBoxes();
      },
      (error) => {
        console.error('❌ Error fetching Textract data:', error);
      }
    );
  }

  scaleBoundingBoxes() {
    if (!this.displayedImageWidth || !this.displayedImageHeight) {
      return;
    }

    this.selectedTextBlock = null;

    this.textBlocks = this.originalTextBlocks.map((block) => {
      const bb = block.Geometry.BoundingBox;
      const pxLeft = bb.Left * this.displayedImageWidth;
      const pxTop = bb.Top * this.displayedImageHeight;
      const pxWidth = bb.Width * this.displayedImageWidth;
      const pxHeight = bb.Height * this.displayedImageHeight;

      return {
        ...block,
        pxLeft: pxLeft + 'px',
        pxTop: pxTop + 'px',
        pxWidth: pxWidth + 'px',
        pxHeight: pxHeight + 'px',
      };
    });
  }

  selectTextBlock(block: any) {
    this.selectedTextBlock = this.selectedTextBlock === block ? null : block;

    if (this.selectedTextBlock) {
      const textToCopy = this.selectedTextBlock.Text;
      this.copyToClipboard(textToCopy);
    }
  }

  copyToClipboard(text: string) {
    if (!navigator.clipboard) {
      console.error('Clipboard API not available');
      return;
    }

    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.snackBar.open('Copied to clipboard!', '', {
          duration: 2000,
          panelClass: ['white-snackbar'],
        });
        console.log(`Copied: ${text}`);
      })
      .catch((err) => {
        console.error('Failed to copy text:', err);
      });
  }

  getCurrentZoomImageValue(): string {
    return this.zoomImageWheelState
      ? `${Math.round(this.zoomImageWheelState.currentZoom * 100)}%`
      : '100%';
  }

  zoomIn() {
    if (!this.zoomImageWheelState) {
      console.warn('zoomIn(): Zoom state is null, cannot zoom in.');
      return;
    }

    const newZoom = this.zoomImageWheelState.currentZoom + 0.5;
    console.log(
      `zoomIn(): Current Zoom: ${this.zoomImageWheelState.currentZoom}, New Zoom: ${newZoom}`
    );

    this.zoomImageWheelService.setZoomImageState({
      currentZoom: newZoom,
    });

    setTimeout(() => {
      console.log(
        `zoomIn(): Updated Zoom: ${this.zoomImageWheelState?.currentZoom}`
      );
    }, 100);
  }

  zoomOut() {
    if (!this.zoomImageWheelState) {
      console.warn('zoomOut(): Zoom state is null, cannot zoom out.');
      return;
    }

    const newZoom = Math.max(0.1, this.zoomImageWheelState.currentZoom - 0.5);
    console.log(
      `zoomOut(): Current Zoom: ${this.zoomImageWheelState.currentZoom}, New Zoom: ${newZoom}`
    );

    this.zoomImageWheelService.setZoomImageState({
      currentZoom: newZoom,
    });

    setTimeout(() => {
      console.log(
        `zoomOut(): Updated Zoom: ${this.zoomImageWheelState?.currentZoom}`
      );
    }, 100);
  }

  // TXT file preview methods
  isTxtFile(fileName: string): boolean {
    return fileName?.toLowerCase().endsWith('.txt');
  }

  isImageFile(fileName: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
    return imageExtensions.some(ext => fileName?.toLowerCase().endsWith(ext));
  }

  getDocumentPreviewIcon(invoice: any): string {
    if (!invoice?.name) return this.localImages.fileDocument;
    if (this.isTxtFile(invoice.name)) return this.localImages.textFileDocument;
    return this.localImages.fileDocument;
  }

  async loadTxtFileContent(invoice: any): Promise<void> {
    if (!invoice?.name || !this.isTxtFile(invoice.name)) {
      this.txtFileContent = '';
      return;
    }

    const invoiceId = invoice.id;
    
    // Check cache first
    if (this.txtContentCache[invoiceId]) {
      this.txtFileContent = this.txtContentCache[invoiceId];
      return;
    }

    this.txtFileLoading = true;
    this.txtFileContent = '';

    try {
      // Extract S3 key from the invoice name
      // invoice.name is a full S3 URL like: https://bucket.s3.amazonaws.com/user-data/file.txt
      let s3Key = invoice.name;
      
      // Check if invoice.name is a full S3 URL
      if (invoice.name.startsWith('https://') || invoice.name.startsWith('http://')) {
        // Extract the key from the URL (everything after the bucket domain)
        const urlMatch = invoice.name.match(/https?:\/\/[^\/]+\/(.+)/);
        if (urlMatch && urlMatch[1]) {
          s3Key = urlMatch[1];
        }
      }
      
      // Use customPrefix to avoid Amplify adding 'public/' prefix
      // since files are stored at root level (e.g., user-data/file.txt)
      const signedUrl = await Storage.get(s3Key, {
        customPrefix: { public: '' }, // Empty prefix - files are not under 'public/'
        level: 'public',
        download: false,
        expires: 300
      });
      
      
      // Fetch the content using the presigned URL
      const response = await this.http.get(signedUrl as string, { responseType: 'text' }).toPromise();
      this.txtFileContent = response || 'File is empty';
      this.txtContentCache[invoiceId] = this.txtFileContent;
    } catch (error) {
      console.error('Error loading TXT file with Storage.get:', error);
      
      // Fallback: Try with download: true for direct blob access
      try {
        let s3Key = invoice.name;
        if (invoice.name.startsWith('https://') || invoice.name.startsWith('http://')) {
          const urlMatch = invoice.name.match(/https?:\/\/[^\/]+\/(.+)/);
          if (urlMatch && urlMatch[1]) {
            s3Key = urlMatch[1];
          }
        }
        
        console.log('Fallback S3 key with download:', s3Key);
        
        const result = await Storage.get(s3Key, {
          customPrefix: { public: '' },
          level: 'public',
          download: true
        });
        
        if (result && (result as any).Body) {
          const blob = (result as any).Body as Blob;
          this.txtFileContent = await blob.text();
          this.txtContentCache[invoiceId] = this.txtFileContent;
        } else {
          this.txtFileContent = 'Unable to load text file content.';
        }
      } catch (fallbackError) {
        console.error('Fallback download failed:', fallbackError);
        this.txtFileContent = 'Unable to load text file content. The file may not be accessible.';
      }
    } finally {
      this.txtFileLoading = false;
    }
  }

  areGoodsAndMaterialFieldsPresent(): boolean {
    if (!this.fullTemplate) {
      return false;
    }
    const result = this.tableHeaders.some((header: any) =>
      this.goodsAndMaterialFields.includes(header)
    );
    return result;
  }

  extractGoodsAndMaterialFields(): string[] {
    if (!this.tableHeaders) {
      return [];
    }

    const filteredFields = this.tableHeaders.filter((header: any) =>
      this.goodsAndMaterialFields.includes(header)
    );

    return filteredFields;
  }

  async ngOnInit(): Promise<void> {
    await this.getTemplates();
    await this.getListOfAllInvoicesIDs();
  }

  async getListOfAllInvoicesIDs() {
    this.invoiceService
      .GetFolderInvoicesIDs(this.folderID, 10000)
      .then((res: any) => {
        this.listOfAllInvoicesIDs = res.invoices.items.map(
          (item: any) => item.id
        );
      });
  }

  onScrollInsideTemplateDialog(event: Event) {
    const scrollContainer = event.target as HTMLElement;
    if (
      scrollContainer.scrollHeight - scrollContainer.scrollTop ===
      scrollContainer.clientHeight
    ) {
      this.fetchMoreTemplatesOnScroll();
    }
  }

  async fetchMoreTemplatesOnScroll() {
    this.isLoading = true;

    if (!this.nextTokenTemplates) {
      return;
    }

    try {
      // Send a request to fetch the latest templates
      let userId = localStorage.getItem('userID');
      const response = await this.templateService2.ListTemplatesByClientID(
        userId as string,
        undefined,
        undefined,
        100,
        this.nextTokenTemplates
      );
      this.nextTokenTemplates = response?.nextToken;

      // Process the fetched data
      const newTemplates = response.items.map((el: any) => {
        el.template = JSON.parse(el.template);
        const keysArray = Object.keys(el.template);
        const keysAsStrings = keysArray.map((key) => String(key));

        let fullTemplate: any = {
          name: el.name,
          description: el.description,
        };
        let additionalFields: any = [];
        for (const [key, value] of Object.entries(el.template)) {
          if (this.templateService2.isMandatoryKey(key)) {
            fullTemplate[key] = value;
          } else {
            additionalFields.push({ key: key, value: value });
          }
        }
        let template: TemplateModel = {
          id: el.id,
          _name: el.name,
          _description: el.description ? el.description : '',
          _updatedAt: el.updatedAt,
          _isFixedValueEnabled: el.isFixedValueEnabled,
          _fixedValues: el.fixedValues
        };

        // Push the new data to the existing arrays
        this.fullTemplates.push({
          template: fullTemplate,
          additionalFields: additionalFields,
          orderedKeys: keysAsStrings,
          id: el.id,
          fixedValues: el.fixedValues || {}, // Add this line
          isFixedValueEnabled: el.isFixedValueEnabled || {} // Add this line
        });
        this.templates.push(template);

        return template;
      });
    } catch (error) {
      console.error('Error fetching templates:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getTemplates() {
    this.data.isTemplatesEmpty = false;
    this.data.templatesList = [];
    this.data.fullTemplates = [];
    this.isLoading = true;

    if (this.selectedTemplateFormat === 'xml') {
      this.templates = [this.xmlTemplate];
      this.data.templatesList = this.templates;
      this.data.fullTemplates = [this.xmlTemplate];
      this.isLoading = false;
      this.isTemplatesEmpty = false;
      return;
    }

    const productsEnabled = this.determineIfGoodsAndMaterial();
    let userId = localStorage.getItem('userID');
    const clientIDProductsEnabledPK = `${userId}#${productsEnabled}`;

    // Send a request to fetch the latest templates
    const response =
      await this.templateService2.ListTemplatesByClientIDProductsEnabledPK(
        clientIDProductsEnabledPK,
        undefined,
        undefined,
        undefined,
        20
      );
    this.nextTokenTemplates = response?.nextToken;

    this.templates = response.items.map((el: any) => {
      el.template = JSON.parse(el.template);
      const keysArray = Object.keys(el.template);
      const keysAsStrings = keysArray.map((key) => String(key));

      const isFixedValueEnabled = el.isFixedValueEnabled ? JSON.parse(el.isFixedValueEnabled) : {};
      const fixedValues = el.fixedValues ? JSON.parse(el.fixedValues) : {};

      let fullTemplate: any = {
        name: el.name,
        description: el.description,
      };
      let additionalFields: any = [];
      for (const [key, value] of Object.entries(el.template)) {
        if (this.templateService2.isMandatoryKey(key)) {
          fullTemplate[key] = value;
        } else {
          additionalFields.push({ key: key, value: value });
        }
      }

      let template: TemplateModel = {
        id: el.id,
        _name: el.name,
        _description: el.description ? el.description : '',
        _updatedAt: el.updatedAt,
        _isFixedValueEnabled: isFixedValueEnabled,
        _fixedValues: fixedValues
      };
      this.fullTemplates.push({
        template: fullTemplate,
        additionalFields: additionalFields,
        orderedKeys: keysAsStrings,
        id: el.id,
        isFixedValueEnabled: isFixedValueEnabled,
        fixedValues: fixedValues
      });
      return template;
    });

    this.data.isTemplatesEmpty = this.isTemplatesEmpty; //: this.isTemplatesEmpty, //treba ga prebaciti u dijalog
    this.data.templatesList = this.templates; //: this.templates,  //treba ga prebaciti u dijalog
    this.data.fullTemplates = this.fullTemplates;

    this.isLoading = false;
    this.isTemplatesEmpty = this.templates.length === 0;
  }

  private isGoodsAndMaterialRequiredFile(fileName: string): boolean {
    const name = fileName?.toLowerCase() || '';
    return name.endsWith('.txt') || name.endsWith('.xlsx') || name.endsWith('.xls');
  }

  determineIfGoodsAndMaterial(): string {
    const invoices = this.data?.duplicatedArray || this.folder?.invoices?.items || [];
    const hasSpecialFiles = invoices.some((invoice: any) =>
      this.isGoodsAndMaterialRequiredFile(invoice?.name)
    );

    if (hasSpecialFiles) {
      return 'TRUE';
    }

    return this.folder['isLatestScanIncludedProducts'] === 'TRUE'
      ? 'TRUE'
      : 'FALSE';
  }

  // get templates new logic end

  getSafePdfUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  doesTemplateHaveEmptyValues() {
    let isEmptyValuePresent = false;
    this.tableRowContent.forEach((el: any, i: number) => {
      const emptyValuePresent = this.doesRowHaveEmptyValues(el, i);
      if (emptyValuePresent) {
        isEmptyValuePresent = true;
      }
    });
    return isEmptyValuePresent;
  }

  closeAdditionalInfo() {
    this.isPreviewTemplate = false;
    setTimeout(() => {
      this.isClosed = false;
    }, 300);
  }

  closeDownloadTemplate() {
    this.tableRowContent = [];
    this.tableHeadersWithoutGoodsAndMaterial = [];
    this.tableHeaders = [];
    let { taxBaseValue, vatValue } = this.initializeFirstFourColumns();

    let currentStep = this.data.duplicatedArray.find(
      (slide: any) => slide.index == this.imageIndex
    );
    currentStep = this.handleVatFieldUpdateInputs(currentStep);
    this.assignTableHeaderRowData();
    this.assignInvoiceInputsToTableRowData(taxBaseValue, vatValue, false);
    this.updateCurrentInvoice(currentStep);
    this.isDownloadPreview = false;
    setTimeout(() => {
      this.isPreviewTemplate = true;
    }, 300);
  }

  closeSelectTemplateAndOpenPreviewTemplateDialog(action: string) {
    if (action === 'run') {
      this.isClosed = true;
      setTimeout(() => {
        this.isPreviewTemplate = true;
      }, 400);
    }
  }

  closePreviewGoodsAndMaterialDialog() {
    this.isPreviewGoodsAndMaterial = false;
    this.openPreviewDialog(this.imageIndex);
  }

  async closeDialogRef() {
    let updatedExtractedResults: any[] = [];
    this.data.duplicatedArray.forEach((step: any) => {
      updatedExtractedResults.push(this.updateExtractedResults(step));
    });

    // Persist every invoice's edits (including konto) to the backend so values
    // survive a reopen/refresh. Without this, updates only live in memory and
    // are lost as soon as the parent component is destroyed.
    await Promise.all(
      updatedExtractedResults.map((payload) =>
        this.invoiceService
          .UpdateInvoice(payload)
          .catch((err) =>
            console.error('Failed to persist invoice edits for', payload.id, err)
          )
      )
    );

    this.isClosed = true;
    setTimeout(() => {
      this.dialogRef.close({ updatedExtractedResults });
    }, 400);
  }

  async selectTemplate(item: any) {
    this.selectedTemplate = item.id;
    this.nextToken = '';
    if (this.loading) return;
    this.resetAndAssignData(item);

    let { taxBaseValue, vatValue } = this.initializeFirstFourColumns();
    this.assignTableHeaderRowData();
    await this.onScroll();
    this.isAllChecked = true;

    if (this.tableHeaders.includes('konto')) {
      await this.loadChartOfAccounts();
    }
    if (this.tableHeaders.includes('schema')) {
      await this.loadAccountSchemas();
    }
    if (this.tableHeaders.some((h: any) => this.isObrjedHeader(h))) {
      await this.loadOrganizationalUnits();
    }
    if (this.tableHeaders.includes('code')) {
      await this.loadCodebookItems();
    }
  }

  async loadChartOfAccounts(): Promise<void> {
    const clientID = localStorage.getItem('userID');
    if (!clientID) return;
    try {
      this.chartOfAccounts = await this.coaDataService.listAllByClientID(clientID);
      this.filteredChartOfAccounts = [...this.chartOfAccounts];
      this.kontoLabelMap = {};
      for (const a of this.chartOfAccounts) {
        this.kontoLabelMap[a.konto] = `${a.konto} \u2013 ${a.nazivKonta}`;
      }
    } catch (err) {
      console.error('Failed to load chart of accounts:', err);
    }
    await this.kontoMappingService.load(clientID);
    this.applyKontoSuggestions();
  }

  async loadAccountSchemas(): Promise<void> {
    const clientID = localStorage.getItem('userID');
    if (!clientID) return;
    try {
      this.accountSchemas = await this.schemaDataService.listAllByClientID(clientID);
      this.schemaLabelMap = {};
      for (const s of this.accountSchemas) {
        this.schemaLabelMap[s.schema] = `${s.schema} \u2013 ${s.nazivSheme}`;
      }
    } catch (err) {
      console.error('Failed to load account schemas:', err);
    }
    await this.schemaMappingService.load(clientID);
    this.applySchemaSuggestions();
  }

  async loadOrganizationalUnits(): Promise<void> {
    const clientID = localStorage.getItem('userID');
    if (!clientID) return;
    try {
      this.organizationalUnits = await this.ouDataService.listAllByClientID(clientID);
      this.filteredOrganizationalUnits = [...this.organizationalUnits];
      this.organizationalUnitLabelMap = {};
      for (const u of this.organizationalUnits) {
        this.organizationalUnitLabelMap[u.code] = `${u.code} \u2013 ${u.name}`;
      }
    } catch (err) {
      console.error('Failed to load organizational units:', err);
    }
  }

  isObrjedHeader(header: any): boolean {
    return typeof header === 'string' && header.toUpperCase() === 'OBRJED';
  }

  isCodeHeader(header: any): boolean {
    return typeof header === 'string' && header === 'code';
  }

  getObrjedColumnIndex(): number {
    return this.tableHeadersWithoutGoodsAndMaterial.findIndex((h: any) => this.isObrjedHeader(h));
  }

  getCodeColumnIndex(): number {
    return this.tableHeadersWithoutGoodsAndMaterial.indexOf('code');
  }

  hasObrjedColumn(): boolean {
    return this.tableHeadersWithoutGoodsAndMaterial.some((h: any) => this.isObrjedHeader(h));
  }

  getFilteredOrganizationalUnits(search: string): OrganizationalUnitModel[] {
    const q = (search || '').toString().toLowerCase().trim();
    if (!q) return this.organizationalUnits;
    return this.organizationalUnits.filter(
      (u) =>
        u.code.toLowerCase().includes(q) ||
        u.name.toLowerCase().includes(q) ||
        `${u.code} \u2013 ${u.name}`.toLowerCase().includes(q)
    );
  }

  // Shows "0001 – HQ" in the input while keeping the underlying ngModel value as the raw code.
  ouDisplayFn = (value: string): string => {
    if (!value) return '';
    return this.organizationalUnitLabelMap[value] || value;
  };

  onObrjedSelected(code: string, rowIndex: number, colIndex: number): void {
    this.tableRowContent[rowIndex][colIndex] = code;
    this.syncObrjedToInvoiceInputs(rowIndex, code);
  }

  onPreviewObrjedSelected(code: string, input: any): void {
    input.value = code;
  }

  getFilteredCodebookItems(search: string): CodebookItem[] {
    const q = (search || '').toString().toLowerCase().trim();
    if (!q) return this.codebookItems;
    return this.codebookItems.filter(
      (cb) =>
        cb.code.toLowerCase().includes(q) ||
        (cb.companyName || '').toLowerCase().includes(q) ||
        (cb.idNumber || '').toLowerCase().includes(q) ||
        (cb.vatNumber || '').toLowerCase().includes(q) ||
        `${cb.code} \u2013 ${cb.companyName}`.toLowerCase().includes(q)
    );
  }

  codeDisplayFn = (value: string): string => {
    if (!value) return '';
    return this.codebookLabelMap[value] || value;
  };

  onCodeSelected(code: string, rowIndex: number, colIndex: number): void {
    this.tableRowContent[rowIndex][colIndex] = code;
    this.syncCodeToInvoiceInputs(rowIndex, code);
  }

  onPreviewCodeSelected(code: string, input: any): void {
    input.value = code;
  }

  // ── Article code (Code (Article)) dropdown ───────────────────────────────
  // Mirrors the partner-code dropdown but for line items: the user picks an
  // article from the price list, and MPC is automatically updated to match.

  private articleFilterCache = new Map<string, any[]>();

  getFilteredPriceListItems(search: string): any[] {
    const items = this.priceListLookupService.allItems;
    const q = (search || '').toString().toLowerCase().trim();
    const cacheKey = q || '__empty__';
    const cached = this.articleFilterCache.get(cacheKey);
    if (cached) return cached;

    let filtered: any[];
    if (!q) {
      filtered = items.slice(0, 100); // cap to keep the UI responsive
    } else {
      filtered = items
        .filter(
          (item: any) =>
            (item.productCode || '').toLowerCase().includes(q) ||
            (item.productName || '').toLowerCase().includes(q) ||
            (item.barcode || '').toLowerCase().includes(q)
        )
        .slice(0, 100); // never render more than 100 options
    }
    this.articleFilterCache.set(cacheKey, filtered);
    return filtered;
  }

  articleCodeDisplayFn = (value: string): string => {
    if (!value) return '';
    return this.articleCodeLabelMap[value] || value;
  };

  /**
   * Called when the user selects an article code from the dropdown in the
   * goods & material table. Updates the articleCode cell AND immediately
   * refreshes the MPC (retailPrice) cell from the price list.
   */
  onArticleCodeSelected(articleCode: string, rowIndex: number): void {
    const articleCodeIndex = this.tableHeaders.indexOf('articleCode');
    const retailPriceIndex = this.tableHeaders.indexOf('retailPrice');

    if (articleCodeIndex > -1) {
      this.tableRowContent[rowIndex][articleCodeIndex] = articleCode;
    }
    // MPC always follows the article code
    if (retailPriceIndex > -1) {
      const mpc = this.priceListLookupService.lookupFormattedByArticleCode(articleCode);
      this.tableRowContent[rowIndex][retailPriceIndex] = mpc;
    }
  }

  private syncObrjedToInvoiceInputs(rowIndex: number, code: string): void {
    const invoice = this.data?.duplicatedArray?.[rowIndex];
    if (!invoice) return;
    if (!Array.isArray(invoice.inputs)) {
      invoice.inputs = [];
    }
    const existing = invoice.inputs.find((el: any) => this.isObrjedHeader(el?.heading));
    if (existing) {
      existing.value = code;
    } else {
      invoice.inputs.push({ heading: 'OBRJED', value: code });
    }
    if (Array.isArray(invoice.missingFields)) {
      invoice.missingFields = invoice.missingFields.filter(
        (f: any) => !this.isObrjedHeader(f)
      );
    }
  }

  // Per-row filter used directly in the template. Does NOT mutate shared state,
  // so selecting in one row doesn't affect other rows' dropdowns.
  getFilteredAccounts(search: string): ChartOfAccountsModel[] {
    const q = (search || '').toString().toLowerCase().trim();
    if (!q) return this.chartOfAccounts;
    // If the input currently shows the rich label ("599 \u2013 ..."), match on any part.
    return this.chartOfAccounts.filter(
      (a) =>
        a.konto.toLowerCase().includes(q) ||
        a.nazivKonta.toLowerCase().includes(q) ||
        `${a.konto} \u2013 ${a.nazivKonta}`.toLowerCase().includes(q)
    );
  }

  // Shows "599 \u2013 Ostali financijski rashodi" in the input while keeping the
  // underlying ngModel value as the raw konto code.
  kontoDisplayFn = (value: string): string => {
    if (!value) return '';
    return this.kontoLabelMap[value] || value;
  };

  // Per-row filter for the `schema` dropdown; same contract as getFilteredAccounts.
  getFilteredSchemas(search: string): AccountSchemaModel[] {
    const q = (search || '').toString().toLowerCase().trim();
    if (!q) return this.accountSchemas;
    return this.accountSchemas.filter(
      (s) =>
        s.schema.toLowerCase().includes(q) ||
        s.nazivSheme.toLowerCase().includes(q) ||
        `${s.schema} \u2013 ${s.nazivSheme}`.toLowerCase().includes(q)
    );
  }

  schemaDisplayFn = (value: string): string => {
    if (!value) return '';
    return this.schemaLabelMap[value] || value;
  };

  private async loadCodebookItems(): Promise<void> {
    const clientID = localStorage.getItem('userID');
    if (!clientID) return;
    try {
      this.codebookItems = await this.codebookLookupService.listAllByClientID(clientID);
      this.codebookLabelMap = {};
      for (const cb of this.codebookItems) {
        this.codebookLabelMap[cb.code] = `${cb.code} \u2013 ${cb.companyName}`;
      }
      this.applyCodebookSuggestions();
    } catch (err) {
      console.error('Failed to load codebook items:', err);
    }
  }

  private applyCodebookSuggestions(): void {
    const codeIndex = this.tableHeadersWithoutGoodsAndMaterial.indexOf('code');
    if (codeIndex < 0) return;
    const idColIndex         = this.tableHeadersWithoutGoodsAndMaterial.indexOf('ID');
    const vatColIndex        = this.tableHeadersWithoutGoodsAndMaterial.indexOf('vatID');
    const companyColIndex    = this.tableHeadersWithoutGoodsAndMaterial.indexOf('companyName');
    this.tableRowContent.forEach((row, i) => {
      if (row[codeIndex]) return;
      const invoiceInputs: any[] = this.data?.duplicatedArray?.[i]?.inputs || [];
      const idVal         = (idColIndex        >= 0 ? row[idColIndex]        : '') || invoiceInputs.find((el: any) => el?.heading === 'ID')?.value          || '';
      const vatVal        = (vatColIndex       >= 0 ? row[vatColIndex]       : '') || invoiceInputs.find((el: any) => el?.heading === 'vatID')?.value       || '';
      // buyer ID/VAT are intentionally not used for codebook lookup (prevents buyer's own code being assigned to supplier invoices)
      const companyVal    = (companyColIndex   >= 0 ? row[companyColIndex]   : '') || invoiceInputs.find((el: any) => el?.heading === 'companyName')?.value || '';
      const code = this.codebookLookupService.lookupCode(this.codebookItems, idVal, vatVal)
               || this.codebookLookupService.lookupCodeByCompanyName(this.codebookItems, companyVal);
      if (code) {
        this.tableRowContent[i][codeIndex] = code;
        this.syncCodeToInvoiceInputs(i, code);
      }
    });
  }

  private syncCodeToInvoiceInputs(rowIndex: number, code: string): void {
    const invoice = this.data?.duplicatedArray?.[rowIndex];
    if (!invoice) return;
    if (!Array.isArray(invoice.inputs)) invoice.inputs = [];
    const existing = invoice.inputs.find((el: any) => el?.heading === 'code');
    if (existing) {
      existing.value = code;
    } else {
      invoice.inputs.push({ heading: 'code', value: code });
    }
    if (Array.isArray(invoice.missingFields)) {
      invoice.missingFields = invoice.missingFields.filter((f: any) => f !== 'code');
    }
  }

  private applyKontoSuggestions(): void {
    const kontoIndex = this.tableHeadersWithoutGoodsAndMaterial.indexOf('konto');
    if (kontoIndex < 0) return;
    const idColIndex          = this.tableHeadersWithoutGoodsAndMaterial.indexOf('ID');
    const vatColIndex         = this.tableHeadersWithoutGoodsAndMaterial.indexOf('vatID');
    const companyColIndex     = this.tableHeadersWithoutGoodsAndMaterial.indexOf('companyName');
    const buyerNameColIndex   = this.tableHeadersWithoutGoodsAndMaterial.indexOf('buyerName');
    this.tableRowContent.forEach((row, i) => {
      if (!row[kontoIndex]) {
        const invoiceInputs: any[] = this.data?.duplicatedArray?.[i]?.inputs || [];
        const idVal      = (idColIndex      >= 0 ? row[idColIndex]      : '') || invoiceInputs.find((el: any) => el?.heading === 'ID')?.value          || '';
        const vatVal     = (vatColIndex     >= 0 ? row[vatColIndex]     : '') || invoiceInputs.find((el: any) => el?.heading === 'vatID')?.value       || '';
        const companyVal = (companyColIndex   >= 0 ? row[companyColIndex]   : '') || invoiceInputs.find((el: any) => el?.heading === 'companyName')?.value
                        || (buyerNameColIndex >= 0 ? row[buyerNameColIndex] : '') || invoiceInputs.find((el: any) => el?.heading === 'buyerName')?.value  || '';
        const suggestion = this.kontoMappingService.getSuggestionForRow(idVal, vatVal, companyVal);
        if (suggestion) {
          this.tableRowContent[i][kontoIndex] = suggestion;
          this.syncKontoToInvoiceInputs(i, suggestion);
        }
      }
    });
  }

  filterKonto(search: string): void {
    const q = (search || '').toLowerCase();
    this.filteredChartOfAccounts = this.chartOfAccounts.filter(
      (a) =>
        a.konto.toLowerCase().includes(q) ||
        a.nazivKonta.toLowerCase().includes(q)
    );
  }

  onPreviewIdOrVatChange(heading: string, value: string): void {
    const isStandard = heading === 'ID' || heading === 'vatID';
    const isBuyer   = heading === 'buyerID' || heading === 'buyerVATID';
    if (!isStandard && !isBuyer) return;
    if (!this.codebookItems?.length) return;

    const inputs: any[] = this.data?.duplicatedArray?.[this.imageIndex]?.inputs || [];

    let idVal: string;
    let vatVal: string;
    if (isBuyer) {
      idVal  = heading === 'buyerID'    ? value : (inputs.find((i: any) => i?.heading === 'buyerID')?.value    || '');
      vatVal = heading === 'buyerVATID' ? value : (inputs.find((i: any) => i?.heading === 'buyerVATID')?.value || '');
    } else {
      idVal  = heading === 'ID'    ? value : (inputs.find((i: any) => i?.heading === 'ID')?.value    || '');
      vatVal = heading === 'vatID' ? value : (inputs.find((i: any) => i?.heading === 'vatID')?.value || '');
    }

    const code = this.codebookLookupService.lookupCode(this.codebookItems, idVal, vatVal);
    if (!code) return;

    const codeInput = inputs.find((i: any) => i?.heading === 'code');
    if (codeInput) {
      codeInput.value = code;
    } else {
      inputs.push({ heading: 'code', value: code });
    }

    const codeColIndex = this.tableHeadersWithoutGoodsAndMaterial.indexOf('code');
    if (codeColIndex >= 0 && this.tableRowContent[this.imageIndex]) {
      this.tableRowContent[this.imageIndex][codeColIndex] = code;
    }
  }

  onPreviewKontoSelected(konto: string, input: any): void {
    input.value = konto;
    const clientID = localStorage.getItem('userID') || '';
    const inputs: any[] = this.data?.duplicatedArray?.[this.imageIndex]?.inputs || [];
    const idValue      = inputs.find((el: any) => el?.heading === 'ID')?.value          || '';
    const vatValue     = inputs.find((el: any) => el?.heading === 'vatID')?.value       || '';
    const companyValue = inputs.find((el: any) => el?.heading === 'companyName')?.value
                      || inputs.find((el: any) => el?.heading === 'buyerName')?.value   || '';
    this.kontoMappingService.record(idValue, vatValue, companyValue, konto, clientID);
  }

  onKontoSelected(konto: string, rowIndex: number, colIndex: number): void {
    this.tableRowContent[rowIndex][colIndex] = konto;
    this.syncKontoToInvoiceInputs(rowIndex, konto);

    const clientID = localStorage.getItem('userID') || '';
    const idColIndex          = this.tableHeadersWithoutGoodsAndMaterial.indexOf('ID');
    const vatColIndex         = this.tableHeadersWithoutGoodsAndMaterial.indexOf('vatID');
    const companyColIndex     = this.tableHeadersWithoutGoodsAndMaterial.indexOf('companyName');
    const buyerNameColIndex   = this.tableHeadersWithoutGoodsAndMaterial.indexOf('buyerName');
    // Prefer table column values; fall back to inputs[] when the field is not
    // part of the selected template's column set.
    const invoiceInputs: any[] = this.data?.duplicatedArray?.[rowIndex]?.inputs || [];
    const idValue      = (idColIndex      >= 0 ? this.tableRowContent[rowIndex][idColIndex]      : '') || invoiceInputs.find((el: any) => el?.heading === 'ID')?.value          || '';
    const vatValue     = (vatColIndex     >= 0 ? this.tableRowContent[rowIndex][vatColIndex]     : '') || invoiceInputs.find((el: any) => el?.heading === 'vatID')?.value       || '';
    const companyValue = (companyColIndex   >= 0 ? this.tableRowContent[rowIndex][companyColIndex]   : '') || invoiceInputs.find((el: any) => el?.heading === 'companyName')?.value
                      || (buyerNameColIndex >= 0 ? this.tableRowContent[rowIndex][buyerNameColIndex] : '') || invoiceInputs.find((el: any) => el?.heading === 'buyerName')?.value  || '';
    this.kontoMappingService.record(idValue, vatValue, companyValue, konto, clientID);
  }

  private syncKontoToInvoiceInputs(rowIndex: number, konto: string): void {
    const invoice = this.data?.duplicatedArray?.[rowIndex];
    if (!invoice) return;
    if (!Array.isArray(invoice.inputs)) {
      invoice.inputs = [];
    }
    const existing = invoice.inputs.find((el: any) => el?.heading === 'konto');
    if (existing) {
      existing.value = konto;
    } else {
      invoice.inputs.push({ heading: 'konto', value: konto });
    }
    // Also drop 'konto' from missingFields if it was marked missing.
    if (Array.isArray(invoice.missingFields)) {
      invoice.missingFields = invoice.missingFields.filter(
        (f: any) => f !== 'konto'
      );
    }
  }

  getKontoSuggestion(rowIndex: number): string {
    const idColIndex          = this.tableHeadersWithoutGoodsAndMaterial.indexOf('ID');
    const vatColIndex         = this.tableHeadersWithoutGoodsAndMaterial.indexOf('vatID');
    const companyColIndex     = this.tableHeadersWithoutGoodsAndMaterial.indexOf('companyName');
    const buyerNameColIndex   = this.tableHeadersWithoutGoodsAndMaterial.indexOf('buyerName');
    const invoiceInputs: any[] = this.data?.duplicatedArray?.[rowIndex]?.inputs || [];
    const idValue      = (idColIndex      >= 0 ? this.tableRowContent[rowIndex]?.[idColIndex]      : '') || invoiceInputs.find((el: any) => el?.heading === 'ID')?.value          || '';
    const vatValue     = (vatColIndex     >= 0 ? this.tableRowContent[rowIndex]?.[vatColIndex]     : '') || invoiceInputs.find((el: any) => el?.heading === 'vatID')?.value       || '';
    const companyValue = (companyColIndex   >= 0 ? this.tableRowContent[rowIndex]?.[companyColIndex]   : '') || invoiceInputs.find((el: any) => el?.heading === 'companyName')?.value
                      || (buyerNameColIndex >= 0 ? this.tableRowContent[rowIndex]?.[buyerNameColIndex] : '') || invoiceInputs.find((el: any) => el?.heading === 'buyerName')?.value  || '';
    return this.kontoMappingService.getSuggestionForRow(idValue, vatValue, companyValue);
  }

  getKontoColumnIndex(): number {
    return this.tableHeadersWithoutGoodsAndMaterial.indexOf('konto');
  }

  hasKontoColumn(): boolean {
    return this.tableHeadersWithoutGoodsAndMaterial.includes('konto');
  }

  // ── Schema (account schema) field ────────────────────────────────────────
  // Mirrors the konto handlers above: dropdown from the Schema codebook plus
  // learned per-supplier suggestions persisted through SchemaMappingService.

  /**
   * Supplier identity (ID / VAT / company) of a row, preferring the table
   * columns and falling back to invoice.inputs[] when a field is not part of
   * the selected template's column set.
   */
  private getRowSupplierIdentity(rowIndex: number): { idValue: string; vatValue: string; companyValue: string } {
    const headers = this.tableHeadersWithoutGoodsAndMaterial;
    const row: any[] = this.tableRowContent[rowIndex] || [];
    const invoiceInputs: any[] = this.data?.duplicatedArray?.[rowIndex]?.inputs || [];
    const fromRowOrInputs = (heading: string): string => {
      const colIndex = headers.indexOf(heading);
      return (colIndex >= 0 ? row[colIndex] : '') || invoiceInputs.find((el: any) => el?.heading === heading)?.value || '';
    };
    return {
      idValue: fromRowOrInputs('ID'),
      vatValue: fromRowOrInputs('vatID'),
      companyValue: fromRowOrInputs('companyName') || fromRowOrInputs('buyerName'),
    };
  }

  private applySchemaSuggestions(): void {
    const schemaIndex = this.tableHeadersWithoutGoodsAndMaterial.indexOf('schema');
    if (schemaIndex < 0) return;
    this.tableRowContent.forEach((row, i) => {
      if (row[schemaIndex]) return;
      const { idValue, vatValue, companyValue } = this.getRowSupplierIdentity(i);
      const suggestion = this.schemaMappingService.getSuggestionForRow(idValue, vatValue, companyValue);
      if (suggestion) {
        this.tableRowContent[i][schemaIndex] = suggestion;
        this.syncSchemaToInvoiceInputs(i, suggestion);
      }
    });
  }

  onPreviewSchemaSelected(schema: string, input: any): void {
    input.value = schema;
    const clientID = localStorage.getItem('userID') || '';
    const inputs: any[] = this.data?.duplicatedArray?.[this.imageIndex]?.inputs || [];
    const idValue      = inputs.find((el: any) => el?.heading === 'ID')?.value          || '';
    const vatValue     = inputs.find((el: any) => el?.heading === 'vatID')?.value       || '';
    const companyValue = inputs.find((el: any) => el?.heading === 'companyName')?.value
                      || inputs.find((el: any) => el?.heading === 'buyerName')?.value   || '';
    this.schemaMappingService.record(idValue, vatValue, companyValue, schema, clientID);
  }

  onSchemaSelected(schema: string, rowIndex: number, colIndex: number): void {
    this.tableRowContent[rowIndex][colIndex] = schema;
    this.syncSchemaToInvoiceInputs(rowIndex, schema);

    const clientID = localStorage.getItem('userID') || '';
    const { idValue, vatValue, companyValue } = this.getRowSupplierIdentity(rowIndex);
    this.schemaMappingService.record(idValue, vatValue, companyValue, schema, clientID);
  }

  private syncSchemaToInvoiceInputs(rowIndex: number, schema: string): void {
    const invoice = this.data?.duplicatedArray?.[rowIndex];
    if (!invoice) return;
    if (!Array.isArray(invoice.inputs)) {
      invoice.inputs = [];
    }
    const existing = invoice.inputs.find((el: any) => el?.heading === 'schema');
    if (existing) {
      existing.value = schema;
    } else {
      invoice.inputs.push({ heading: 'schema', value: schema });
    }
    if (Array.isArray(invoice.missingFields)) {
      invoice.missingFields = invoice.missingFields.filter(
        (f: any) => f !== 'schema'
      );
    }
  }

  private isAtEnd = false; // Initialize a flag

  async onScrollSimple() {
    const table = this.tableRef.nativeElement;
    const scrollThreshold = 10;
    const isAtEnd =
      table.scrollHeight - table.scrollTop <=
      table.clientHeight + scrollThreshold;

    if (isAtEnd && !this.isAtEnd) {
      this.isAtEnd = true;
      await this.onScroll();
    } else if (!isAtEnd) {
      this.isAtEnd = false;
    }
  }

  async onScroll() {
    let newFreshItems: any = [];
    if (this.nextToken === '' && this.data.duplicatedArray.length) {
      return;
    }
    await this.invoiceService
      .GetFolder(this.folderID, 200, this.nextToken)
      .then((data: any) => {
        if (data?.invoices?.items) {
          data?.invoices?.items.forEach((el: any, index: any, array: any) => {
            el.index = this.data.duplicatedArray.length + index;
            el.inputs = [];
            el.missingFields = JSON.parse(el.missingFields);
            if (el.extractedResults) {
              const extractedResults = JSON.parse(el.extractedResults);
              for (const [key, value] of Object.entries(extractedResults)) {
                el.inputs.push({ value: value, heading: key });
              }
            }
            if (el.missingFields) {
              el.missingFields.forEach((field: any) => {
                el.inputs.push({ value: '', heading: field });
              });
            }
          });
        }

        newFreshItems = data?.invoices?.items;
        if (data.invoices.nextToken) {
          this.nextToken = data.invoices.nextToken;
        } else {
          this.nextToken = '';
        }
      });
    let { taxBaseValue, vatValue } = this.initializeFirstFourColumns();
    this.data.duplicatedArray = this.data.duplicatedArray.concat(newFreshItems);
    this.assignInvoiceInputsToTableRowData(taxBaseValue, vatValue, true);
    // Re-run auto-suggestions for the newly appended rows so their values are
    // synced into invoice.inputs and persisted when the dialog closes.
    this.applyKontoSuggestions();
    this.applySchemaSuggestions();
    this.applyCodebookSuggestions();
  }

  private assignInvoiceInputsToTableRowData(
    taxBaseValue: string,
    vatValue: string,
    initialLoad: boolean
  ) {
    let taxBaseValues: string[] = [];
    let vatValues: string[] = [];
    this.data.duplicatedArray.forEach((element: any, index: any) => {
      this.tableRowContent.push([]);

      if (initialLoad) {
        this.vatIncludedCheckbox[index] = true;
      }
      const taxBaseInput = element.inputs.find(
        (el: any) => el.heading === 'taxBase'
      );
      const VATInput = element.inputs.find((el: any) => el.heading === 'vat');
      taxBaseValues.push(taxBaseInput?.value);
      vatValues.push(VATInput?.value);

      this.taxBaseValues = Array.from(taxBaseValues);
      this.vatValues = Array.from(vatValues);

      // Filtering out goods and material fields
      const filteredTableHeaders = this.tableHeaders.filter(
        (heading) => !this.goodsAndMaterialFields.includes(heading)
      );

      filteredTableHeaders.forEach((heading: any) => {
        let inputItem = element.inputs.find(
          (item: any) => item.heading === heading
        );
        if ((heading === 'ID' || heading === 'vatID') &&
          this.fullTemplate.isFixedValueEnabled[heading] &&
          this.fullTemplate.fixedValues[heading]) {
          // Use the fixed value instead of extracted value
          if (inputItem) {
            inputItem.value = this.fullTemplate.fixedValues[heading];
          } else {
            inputItem = { value: this.fullTemplate.fixedValues[heading], heading: heading };
            element.inputs.push(inputItem);
          }
        }
        if (initialLoad) {
          this.fullTemplate.additionalFields.forEach((el: any) => {
            if (el.key === heading) {
              if (el.value && inputItem) {
                inputItem.value = el.value;
                element.inputs.push({
                  value: el.value,
                  heading: this.returnHeaderValue(heading),
                });
              } else if (el.value && !inputItem) {
                inputItem = { value: el.value, heading: el.heading };
                element.inputs.push({
                  value: el.value,
                  heading: this.returnHeaderValue(heading),
                });
              }
            }
          });
        }
        if (!inputItem) {
          const inputWithValue = this.fullTemplate.additionalFields.find(
            (el: { key: string; value: string }) => el.key === heading
          );
          if (inputWithValue) {
            element.inputs.push({
              value: inputWithValue.value,
              heading: heading,
            });
          } else {
            element.inputs.push({ value: '', heading: heading });
          }
        }

        if (this.vatFields.includes(heading)) {
          if (
            this.tableRowContent[index].length >= filteredTableHeaders.length
          ) {
            return;
          }
          this.tableRowContent[index].push('');
          return;
        }

        if (inputItem) {
          if (
            this.tableRowContent[index].length >= filteredTableHeaders.length
          ) {
            return;
          }
          this.tableRowContent[index].push(inputItem.value);
        } else if (
          !inputItem &&
          this.fullTemplate.additionalFields.some(
            (el: { key: string; value: string }) => el.key === heading
          )
        ) {
          this.tableRowContent[index].push('');
        } else if (!inputItem) {
          this.tableRowContent[index].push('');
        }
      });
      if (taxBaseInput) {
        const deductibleTaxBaseInput = element.inputs.find(
          (el: any) => el.heading === 'deductibleTaxBase'
        );
        if (deductibleTaxBaseInput) {
          deductibleTaxBaseInput.value = taxBaseInput?.value;
        }
      }
      if (VATInput) {
        const deductibleVATInput = element.inputs.find(
          (el: any) => el.heading === 'deductibleVAT'
        );
        if (deductibleVATInput) {
          deductibleVATInput.value = VATInput?.value;
        }
      }
    });

    this.isVatMissing = !vatValues;
    this.isTaxBaseMissing = !taxBaseValues;

    if (
      this.tableHeaders.includes('deductibleTaxBase') ||
      this.tableHeaders.includes('nonDeductibleTaxBase')
    ) {
      let index = this.tableHeaders.indexOf('deductibleTaxBase');
      let indexnon = this.tableHeaders.indexOf('nonDeductibleTaxBase');
      if (index < 0) {
        index = indexnon;
      }
      taxBaseValues.forEach((el: any, i: number) => {
        if (el) {
          const vatIncluded = this.vatIncludedCheckbox[i];
          this.tableRowContent[i][vatIncluded ? index : indexnon] = el;
        }
      });
    }
    if (
      this.tableHeaders.includes('deductibleVAT') ||
      this.tableHeaders.includes('nonDeductibleVAT')
    ) {
      let indexVat = this.tableHeaders.indexOf('deductibleVAT');
      let indexnonVat = this.tableHeaders.indexOf('nonDeductibleVAT');
      if (indexVat < 0) {
        indexVat = indexnonVat;
      }
      vatValues.forEach((el: any, i: number) => {
        if (el) {
          const vatIncluded = this.vatIncludedCheckbox[i];
          this.tableRowContent[i][vatIncluded ? indexVat : indexnonVat] = el;
        }
      });
    }
  }

  filterAccordingToTemplate(inputs: any[]) {
    const selectedHeadings = Object.values(this.fullTemplate.template).concat(
      this.fullTemplate.additionalFields.map((field: any) => field.key)
    );
    const x = inputs.filter(
      (input: any) =>
        selectedHeadings.includes(this.returnHeaderValue(input.heading)) &&
        input.heading !== 'description'
      // description field is taken from the extracted results all the time
      // because the template description is coupled with the template's mapping
      // description will always be in this.fullTemplate.template, see invoice-folder.component.ts line 151 - 162
    );
    // const uniqueData = x.reduce((acc, current) => {
    //   const existing = acc.find((item: any) => item.heading === current.heading);
    //   if (!existing) {
    //     acc.push(current);
    //   }
    //   return acc;
    // }, []);

    // return uniqueData;
    return x;
  }

  returnHeaderValue(header: string) {
    let template = this.fullTemplate.template[header];
    if (template) {
      return template;
    }
    return header;
  }

  private assignTableHeaderRowData() {
    // orderedKeys keeps the column order the user picked in the template
    // editor. Older payloads without it fall back to mandatory fields first.
    const orderedKeys = this.fullTemplate.orderedKeys?.length
      ? this.fullTemplate.orderedKeys
      : Object.keys(this.fullTemplate.template).concat(
          this.fullTemplate.additionalFields.map((el: any) => el.key)
        );

    for (const key of orderedKeys) {
      if (
        key !== 'name' &&
        key !== 'description' &&
        key !== 'documentIndex'
      ) {
        this.tableHeaders.push(key);
        if (!this.goodsAndMaterialFields.includes(key)) {
          this.tableHeadersWithoutGoodsAndMaterial.push(key);
        }
      }
      if (key === 'documentIndex') {
        this.documentIndexValue[key] = this.fullTemplate.template[key];
      }
    }
  }

  private initializeFirstFourColumns() {
    let taxBaseValue: any;
    let vatValue: any;

    for (const [key, value] of Object.entries(this.fullTemplate.template)) {
      if (key === 'deductibleTaxBase' || key === 'deductibleVAT') {
        if (value) {
          if (key === 'deductibleTaxBase') {
            taxBaseValue = key;
          } else {
            vatValue = key;
          }
        } else {
          if (key === 'deductibleTaxBase') {
            taxBaseValue = key;
          } else {
            vatValue = key;
          }
        }
      }
    }
    return { taxBaseValue, vatValue };
  }

  extractColumnValues(
    tableHeaders: string[],
    tableRows: any[][],
    columnName: string
  ): any[] {
    const columnIndex = tableHeaders.indexOf(columnName);
    if (columnIndex === -1) {
      throw new Error(`Column '${columnName}' not found in table headers.`);
    }

    return tableRows.map((row) => {
      return row[columnIndex];
    });
  }

  private resetAndAssignData(item: any) {
    this.tableRowContent = [];
    this.tableHeaders = [];
    this.tableHeadersWithoutGoodsAndMaterial = [];
    this.documentIndexValue = {};
    this.template = item;
    this.data.duplicatedArray = [];
    // this.nextToken = ''
    this.fullTemplate = this.data.fullTemplates.find(
      (el: any) => el.template['name'] === item._name
    );
  }

  toggleArrayElements(array: any, firstIndex: any, secondIndex: any) {
    const temp = array[firstIndex];
    array[firstIndex] = array[secondIndex];
    array[secondIndex] = temp;
  }

  toggleFirstAndThird(row: any, index: any) {
    let hasFalse = false;
    setTimeout(() => {
      for (const key in this.vatIncludedCheckbox) {
        if (this.vatIncludedCheckbox[key] === false) {
          hasFalse = true;
          break;
        }
      }
      this.isAllChecked = !hasFalse;
      if (this.vatIncludedCheckbox[index]) {
        this.toggleElementsInRow(row);
      } else {
        this.toggleElementsInRow(row);
      }
    }, 50);
  }

  private toggleRowElementValue(
    row: Array<any>,
    index: number | undefined,
    value: string | undefined
  ) {
    if (index == undefined || index < 0) return;
    row[index] = value === row[index] ? '' : value;
  }

  private toggleElementsInRow(row: any) {
    const rowIndex = this.tableRowContent.findIndex((a) =>
      this.arraysEqual(a, row)
    );

    const {
      indexTaxBase,
      indexNonDeductibleTaxBase,
      indexVAT,
      indexNonDeductibleVAT,
    } = this.checkWhichAttributeIsIncluded();

    if (indexTaxBase >= 0 && indexNonDeductibleTaxBase >= 0) {
      this.toggleRowElementValue(
        row,
        indexNonDeductibleTaxBase,
        this.taxBaseValues![rowIndex]
      );
      this.toggleRowElementValue(
        row,
        indexTaxBase,
        this.taxBaseValues![rowIndex]
      );
    }

    if (indexVAT >= 0 && indexNonDeductibleVAT >= 0) {
      this.toggleRowElementValue(row, indexVAT, this.vatValues![rowIndex]);
      this.toggleRowElementValue(
        row,
        indexNonDeductibleVAT,
        this.vatValues![rowIndex]
      );
    }
  }

  private checkWhichAttributeIsIncluded() {
    const indexTaxBase = this.tableHeaders.indexOf('deductibleTaxBase');
    const indexNonDeductibleTaxBase = this.tableHeaders.indexOf(
      'nonDeductibleTaxBase'
    );
    const indexVAT = this.tableHeaders.indexOf('deductibleVAT');
    const indexNonDeductibleVAT = this.tableHeaders.indexOf('nonDeductibleVAT');
    return {
      indexTaxBase,
      indexNonDeductibleTaxBase,
      indexVAT,
      indexNonDeductibleVAT,
    };
  }

  toggleAll() {
    if (this.isAllChecked) {
      this.tableRowContent.forEach((el, index) => {
        if (this.vatIncludedCheckbox[index]) {
          this.toggleElementsInRow(el);
        }
      });
    } else {
      this.tableRowContent.forEach((el, index) => {
        if (this.vatIncludedCheckbox[index] === false) {
          this.toggleElementsInRow(el);
        }
      });
    }
    this.toggleObjectValues(this.vatIncludedCheckbox, !this.isAllChecked);
  }

  currentAngle = 0;

  rotateImage(
    degrees: number = 90,
    updateLocalInvoiceRotateAngle: boolean = false
  ) {
    console.log('rotateImage(): current currentAngle:' + this.currentAngle);
    const newAngle = this.currentAngle + degrees;
    const image = document.getElementById('rotatingImage');
    if (image) {
      this.renderer.setStyle(image, 'transform', `rotate(${newAngle}deg)`);
      console.log('rotateImage(): current angle:' + newAngle);
    }

    setTimeout(() => {
      this.currentAngle = newAngle % 360;
      if (updateLocalInvoiceRotateAngle) {
        this.data.duplicatedArray[this.imageIndex].rotateAngle =
          this.currentAngle;
      }
      console.log('rotateImage(): updated current angle:' + this.currentAngle);
    }, 300);
  }

  getLensWidth() {
    return this.isVerticalRotation() ? 140 : 300;
  }

  getLensHeight() {
    return this.isVerticalRotation() ? 300 : 140;
  }

  isVerticalRotation() {
    return this.currentAngle % 180 !== 0;
  }

  async openPreviewGoodsAndMaterialDialog(selectedInvoice: any) {
    this.isDownloadPreview = false;

    this.assignGoodsAndMaterialHeaderRowData(selectedInvoice);
    // The price list is needed when the template maps an MPC column OR an
    // articleCode column (the article dropdown is populated from it). It has
    // to be indexed before the rows are built so the columns are populated.
    if (this.tableHeaders.includes('retailPrice') || this.tableHeaders.includes('articleCode')) {
      await this.loadPriceListItems();
    }
    this.assignGoodsAndMaterialRowData(selectedInvoice);
    this.currentInvoice = selectedInvoice;
    this.initialExtractedProductsResults = JSON.parse(
      JSON.stringify(selectedInvoice.extractedProductsResults)
    );

    // Bank statements: fill the izvod columns from the IZ/PR XML and apply
    // the posting rules of the statement's company account.
    await this.loadBankStatementData(selectedInvoice);

    // Initialize checkbox state for each row
    this.rowUseCash = {};
    this.rowSyncToEPO = {};
    if (this.isTxtFile(selectedInvoice.name)) {
      this.tableRowContent.forEach((_, index) => {
        this.rowUseCash[index] = false;
        this.rowSyncToEPO[index] = false;
      });
      // Load existing checkbox values if they exist
      this.loadExistingCheckboxValues(selectedInvoice);
    }

    this.currentAngle = selectedInvoice.rotateAngle || 0;
    console.log(
      'openPreviewGoodsAndMaterialDialog(): current angle:' + this.currentAngle
    );
    this.rotateImage(0);

    setTimeout(() => {
      this.isPreviewGoodsAndMaterial = true;
      // Initialize zoom after modal is visible (handles cached images)
      setTimeout(() => {
        this.initGoodsAndMaterialsZoom();
      }, 200);
    }, 180);
  }

  initGoodsAndMaterialsZoom() {
    console.log('🔧 initGoodsAndMaterialsZoom() called');

    const goodsModal = document.querySelector('.preview-goods-and-materials-wrapper');
    if (!goodsModal) {
      console.error('❌ Goods and Materials modal not found.');
      return;
    }

    const imageEl = goodsModal.querySelector('.uploaded-image') as HTMLImageElement | null;
    // Use .rotating-image as the zoom container (it directly contains the image)
    const rotatingImageEl = goodsModal.querySelector('.rotating-image') as HTMLDivElement | null;

    if (!imageEl || !rotatingImageEl) {
      console.error('❌ Image or rotating-image container not found in Goods and Materials modal.');
      return;
    }

    // Reassign ViewChild references
    (this.imageElement as any) = new ElementRef(imageEl);
    (this.imageWheelContainerRef as any) = new ElementRef(rotatingImageEl);

    this.displayedImageWidth = imageEl.clientWidth;
    this.displayedImageHeight = imageEl.clientHeight;

    console.log('📐 Image dimensions:', this.displayedImageWidth, 'x', this.displayedImageHeight);

    // Reset previous zoom state if exists
    if (this.zoomImageWheelState) {
      console.log('🛑 Resetting previous zoom instance...');
      this.zoomImageWheelService.setZoomImageState({ currentZoom: 1 });
      this.zoomImageWheelState = null;
    }

    // Initialize zoom on the rotating-image container
    console.log('🚀 Initializing zoom for Goods and Materials on rotating-image...');
    this.zoomImageWheelService.createZoomImage(rotatingImageEl);

    // Fetch Textract data if invoice exists
    if (this.data.duplicatedArray[this.imageIndex]) {
      const textractUrl = `https://${environment.s3BucketName}.s3.eu-central-1.amazonaws.com/public/invoiceLabels/${this.data.duplicatedArray[this.imageIndex].id}.json`;
      console.log('Fetching Textract data from:', textractUrl);
      this.fetchTextractData(textractUrl);
    }

    // Subscribe to zoom state
    this.zoomImageWheelService.zoomImageState$.subscribe((state) => {
      this.zoomImageWheelState = state;
      const { currentZoom, currentPositionX, currentPositionY, currentRotation } = state;
      this.overlayTransform = `
        translate(${currentPositionX}px, ${currentPositionY}px)
        scale(${currentZoom})
        rotate(${currentRotation + this.currentAngle}deg)
      `;
    });
  }

  private assignGoodsAndMaterialHeaderRowData(invoice: any) {
    this.tableHeaders = [];

    // orderedKeys keeps the column order the user picked in the template
    // editor (e.g. articleCode first). Older payloads without it fall back
    // to mandatory fields first, then additional fields.
    const orderedKeys = this.fullTemplate.orderedKeys?.length
      ? this.fullTemplate.orderedKeys
      : Object.keys(this.fullTemplate.template).concat(
          this.fullTemplate.additionalFields.map((el: any) => el.key)
        );

    orderedKeys.forEach((key: string) => {
      if (this.goodsAndMaterialFields.includes(key)) {
        this.tableHeaders.push(key.trim());
      }
    });

    // Removing duplicates and empty headers from tableHeaders
    this.tableHeaders = Array.from(new Set(this.tableHeaders)).filter(
      (header) => header !== ''
    );
  }

  /**
   * Load the client's price list once per dialog so the retailPrice (MPC) column
   * can be resolved. Deliberately lazy: a price list runs to tens of thousands
   * of rows, so it is only fetched when the template actually shows that column.
   */
  private async loadPriceListItems(): Promise<void> {
    if (this.priceListLookupService.isLoaded) return;
    if (this.priceListLoading) return this.priceListLoading;

    const clientID = localStorage.getItem('userID');
    if (!clientID) return;

    this.priceListLoading = (async () => {
      try {
        const items = await this.priceListDataService.listAllForLookup(clientID);
        this.priceListLookupService.buildIndex(items, clientID);
        // Build an O(1) label map so the article code display/dropdown are fast.
        this.articleCodeLabelMap = {};
        this.articleFilterCache.clear();
        for (const item of this.priceListLookupService.allItems) {
          if (item?.productCode) {
            this.articleCodeLabelMap[item.productCode] =
              `${item.productCode} – ${item.productName}`;
          }
        }
      } catch (err) {
        console.error('Failed to load the price list:', err);
      } finally {
        this.priceListLoading = null;
      }
    })();

    return this.priceListLoading;
  }

  private assignGoodsAndMaterialRowData(invoice: any) {
    this.tableRowContent = [];

    console.log('Assigning goods and material row data...');
    console.log('Processing invoice:', invoice);

    // Fields that must always be displayed with four decimal places.
    // Values arrive as European-formatted strings (comma = decimal separator),
    // e.g. "1,15" or "12" or "3,00". They are parsed, padded to 4 decimals,
    // and emitted back with a comma separator to match the Bosnian format.
    //
    // priceWithoutTax is deliberately excluded: unit prices are printed on the
    // invoice with two, three or four decimals (15,385 / 7,692) and must be
    // shown exactly as printed. Padding them turned 15,385 into 15,3850.
    const fourDecimalFields = new Set(['discountPercentage', 'quantity']);

    if (invoice.extractedProductsResults) {
      try {
        const extractedProductsResults = JSON.parse(
          invoice.extractedProductsResults
        );
        console.log(
          'Parsed extractedProductsResults:',
          JSON.stringify(extractedProductsResults, null, 2)
        );

        const articleCodeIndex = this.tableHeaders.indexOf('articleCode');
        const retailPriceIndex = this.tableHeaders.indexOf('retailPrice');

        extractedProductsResults.items.forEach((product: any) => {
          const row: any[] = [];
          this.tableHeaders.forEach((header) => {
            let value = product[header] ? String(product[header]).trim() : '';
            if (fourDecimalFields.has(header) && value) {
              value = this.formatToFourDecimals(value);
            }
            row.push(value);
          });

          // ── Article code + MPC resolution ──────────────────────────────
          // The article code is resolved from the price list by barcode →
          // product code → product name. Once the article code is known, MPC
          // is ALWAYS pulled from the price list for that article code. MPC
          // never comes from the invoice — the invoice-extracted retailPrice
          // is ignored so that incorrect OCR readings don't pollute the MPC.
          if (articleCodeIndex > -1 || retailPriceIndex > -1) {
            // If the invoice already carried an articleCode (e.g. from the
            // backend priceListIntegration), trust it; otherwise look it up.
            let articleCode = articleCodeIndex > -1 ? row[articleCodeIndex] : '';
            if (!articleCode) {
              articleCode = this.priceListLookupService.lookupArticleCode({
                barcode: product.barcode,
                productCode: product.productCode,
                productName: product.productName,
              });
              if (articleCode && articleCodeIndex > -1) {
                row[articleCodeIndex] = articleCode;
              }
            }

            // MPC always comes from the price list via the article code.
            if (retailPriceIndex > -1) {
              const mpc = this.priceListLookupService.lookupFormattedByArticleCode(articleCode);
              row[retailPriceIndex] = mpc; // '' when no match — that's correct
            }
          }

          this.tableRowContent.push(row);
        });
      } catch (error) {
        console.error('Error parsing extractedProductsResults:', error);
      }
    } else {
      console.warn('No extractedProductsResults found for invoice:', invoice);
    }

    console.log('Final table row content:', this.tableRowContent);
  }

  /**
   * Format a European-formatted numeric string to exactly four decimal places,
   * preserving the comma as the decimal separator.
   *
   * Input examples:  "1,15" | "12" | "3,00" | "1.234,56" | "0"
   * Output examples: "1,1500" | "12,0000" | "3,0000" | "1234,5600" | "0,0000"
   *
   * Non-numeric or empty input is returned unchanged so text values are not
   * corrupted.
   */
  private formatToFourDecimals(value: string): string {
    if (!value) return value;
    // European format: dot is the thousands separator, comma is the decimal.
    // Strip thousands separators (dots), then convert comma to dot for parsing.
    const cleaned = value.replace(/\./g, '').replace(',', '.');
    const num = Number(cleaned);
    if (isNaN(num)) return value;
    return num.toFixed(4).replace('.', ',');
  }

  isGoodsAndMaterialField(header: string): boolean {
    return this.goodsAndMaterialFields.includes(header);
  }

  openPreviewDialog(index: any, degrees?: number, savedInvoice?: any) {
    this.imageIndex = index;
    this.prepareForEdit(index);
    // Ensure chart of accounts is available for the konto autocomplete in the
    // preview panel (may not have been loaded if user skips template selection).
    if (this.chartOfAccounts.length === 0) {
      this.loadChartOfAccounts();
    }
    // Same for the account schemas behind the `schema` autocomplete.
    if (this.accountSchemas.length === 0) {
      this.loadAccountSchemas();
    }
    // Ensure organizational units are loaded for the OBRJED autocomplete in the preview panel.
    if (this.organizationalUnits.length === 0) {
      this.loadOrganizationalUnits();
    }
    // Ensure codebook items are loaded so onPreviewIdOrVatChange can auto-assign
    // the code when the user corrects an ID or VAT number in the preview.
    if (this.codebookItems.length === 0) {
      this.loadCodebookItems();
    }
    const invoice = JSON.parse(
      JSON.stringify(this.data.duplicatedArray[index])
    );
    this.selectedInvoiceCopy = invoice;
    this.isPreviewTemplate = false;
    
    // Load TXT file content if applicable
    if (this.isTxtFile(this.data.duplicatedArray[index]?.name)) {
      this.loadTxtFileContent(this.data.duplicatedArray[index]);
    }
    
    setTimeout(() => {
      this.imageSrc = this.data.duplicatedArray[index]?.thumbnailPath;
      this.isDownloadPreview = true;
      this.currentAngle =
        degrees || this.selectedInvoiceCopy.rotateAngle % 360 || 0;
      console.log('openPreviewDialog(): currentAngle:' + this.currentAngle);
      this.rotateImage(0);
      setTimeout(() => {
        this.onImageLoad();
      }, 0);
    }, 600);
  }

  saveAndBack() {
    if (this.currentInvoice) {
      this.isLoadingButton = true;

      const updatedProducts = {
        items: this.tableRowContent.map((row: any[], rowIndex: number) => {
          const product: any = {};
          this.extractGoodsAndMaterialFields().forEach(
            (header: string, index: number) => {
              product[header] = row[index].trim();
            }
          );
          // Add checkbox values for bank statement rows
          if (this.isBankStatement()) {
            if (this.rowUseCash[rowIndex] !== undefined) {
              product.useCash = this.rowUseCash[rowIndex];
            }
            if (this.rowSyncToEPO[rowIndex] !== undefined) {
              product.syncToEPO = this.rowSyncToEPO[rowIndex];
            }
            if (this.rowBankManualKonto[rowIndex]) product.bankManualKonto = true;
            if (this.rowBankManualPartner[rowIndex]) product.bankManualPartner = true;
          }
          return product;
        }),
      };

      this.currentInvoice.extractedProductsResults = JSON.stringify(
        updatedProducts,
        null,
        2
      );

      // Updating the rotateAngle in the duplicatedArray
      this.data.duplicatedArray[this.imageIndex].rotateAngle =
        this.currentAngle;

      // Calling the service method to save the updated invoice back to the backend
      this.invoiceService
        .UpdateInvoice({
          id: this.currentInvoice.id,
          extractedProductsResults:
            this.currentInvoice.extractedProductsResults,
          rotateAngle: this.currentAngle,
        })
        .then((response) => {
          console.log('Update successful:', response);

          // Updating initial extractedProductsResults
          this.initialExtractedProductsResults = JSON.stringify(
            updatedProducts,
            null,
            2
          );

          // Closing the dialog for goods and material
          this.isPreviewGoodsAndMaterial = false;
          this.currentInvoice = null;

          // Opening the preview dialog after saving
          setTimeout(() => {
            this.isLoadingButton = false;
            this.openPreviewDialog(this.imageIndex, this.currentAngle);
          }, 300);
        })
        .catch((error) => {
          this.isLoadingButton = false;
          console.error('Error updating invoice:', error);
        });
    } else {
      this.isLoadingButton = false;
      console.warn('No selected invoice found to update.');
    }
  }

  isBankStatement(): boolean {
    return this.currentInvoice && this.isTxtFile(this.currentInvoice.name);
  }

  // ─── Bank statement (izvod) columns, XML and posting rules ────────────────

  /** Company bank account (RACUN) of the statement open in the preview. */
  get bankCompanyAccount(): string {
    return this.bankXml?.header?.racun || '';
  }

  hasBankStatementColumns(): boolean {
    return this.tableHeaders.some((h: string) => isBankStatementField(h));
  }

  /**
   * "U gotovu" / "Sync Ostalo to EPO/KP" checkbox columns. Templates that
   * use the izvod fields switch them on/off like any other column; templates
   * created before those fields existed keep showing both, as they always did.
   */
  showBankCheckboxColumn(key: 'bankUseCash' | 'bankSyncToEPO'): boolean {
    if (!this.isBankStatement()) return false;
    const template = this.fullTemplate?.template || {};
    const usesIzvodFields = Object.keys(template).some((k) => isBankStatementField(k));
    return usesIzvodFields ? !!template[key] : true;
  }

  /** Columns copied from the statement itself; the user cannot edit them. */
  isBankReadonlyField(header: string): boolean {
    return ['bankOpis1', 'bankOpis2', 'bankSvrhaDoznake', 'bankDuguje', 'bankPotrazuje', 'bankIdBroj'].includes(header);
  }

  /** Izvod columns that render their own cell instead of the plain input. */
  isGoodsBankSpecialCell(header: string): boolean {
    return header === 'bankKonto' || header === 'bankSifraPartnera' || this.isBankReadonlyField(header);
  }

  private bankColumnIndex(key: string): number {
    return this.tableHeaders.indexOf(key);
  }

  /** Same shape hasChanges() compares against, used to reset the baseline. */
  private serializeRowsForCompare(): string {
    const items = this.tableRowContent.map((row: any[]) => {
      const product: any = {};
      this.extractGoodsAndMaterialFields().forEach((header: string, index: number) => {
        product[header] = (row[index] ?? '').toString().trim();
      });
      return product;
    });
    return JSON.stringify({ items }, null, 2);
  }

  private async loadBankStatementData(invoice: any): Promise<void> {
    this.bankXml = null;
    this.bankRules = [];
    this.rowBankManualKonto = {};
    this.rowBankManualPartner = {};
    if (!invoice?.id || !this.isTxtFile(invoice.name) || !this.hasBankStatementColumns()) return;
    this.loadBankManualFlags(invoice);

    this.bankXmlLoading = true;
    try {
      this.bankXml = await this.bankXmlService.load(invoice.id);
      if (!this.bankXml) {
        console.warn(`[BankStatement] No IZ/PR XML found for invoice ${invoice.id}; izvod columns stay empty`);
        return;
      }
      this.mergeBankXmlIntoRows();

      const loaders: Promise<any>[] = [];
      if (this.bankColumnIndex('bankKonto') > -1 && this.chartOfAccounts.length === 0) {
        loaders.push(this.loadChartOfAccounts());
      }
      if ((this.bankColumnIndex('bankSifraPartnera') > -1 || this.bankColumnIndex('bankIdBroj') > -1)
          && this.codebookItems.length === 0) {
        loaders.push(this.loadCodebookItems());
      }
      await Promise.all(loaders);
      this.tableRowContent.forEach((_, i) => this.refreshBankIdBroj(i));

      // Values copied from the statement are not user edits: reset the
      // change baseline here so only edits and rule suggestions enable Save.
      this.initialExtractedProductsResults = this.serializeRowsForCompare();

      await this.reloadBankRules();
      this.applyBankRulesToRows();
    } catch (err) {
      console.error('[BankStatement] Loading statement data failed:', err);
    } finally {
      this.bankXmlLoading = false;
    }
  }

  /**
   * Copy Opis_1 / Opis_2 / Svrha / Duguje / Potrazuje from the XML rows into
   * the table. The XML and the stored items were both produced from the same
   * TXT, row for row, so they are matched by position.
   */
  private mergeBankXmlIntoRows(): void {
    if (!this.bankXml) return;
    const map: { [key: string]: keyof BankStatementXml['rows'][number] } = {
      bankOpis1: 'opis1',
      bankOpis2: 'opis2',
      bankSvrhaDoznake: 'svrha',
      bankDuguje: 'duguje',
      bankPotrazuje: 'potrazuje',
    };
    const columns = Object.entries(map)
      .map(([key, prop]) => ({ index: this.bankColumnIndex(key), prop }))
      .filter((c) => c.index > -1);
    if (!columns.length) return;

    while (this.tableRowContent.length < this.bankXml.rows.length) {
      this.tableRowContent.push(this.tableHeaders.map(() => ''));
    }
    this.bankXml.rows.forEach((xmlRow, i) => {
      for (const c of columns) {
        this.tableRowContent[i][c.index] = (xmlRow[c.prop] || '').toString();
      }
    });
  }

  /** The row values posting rules are matched against. */
  private bankRowValues(rowIndex: number): BankStatementRowValues {
    const xmlRow = this.bankXml?.rows[rowIndex];
    if (xmlRow) {
      return { opis1: xmlRow.opis1, opis2: xmlRow.opis2, opis3: xmlRow.opis3, svrha: xmlRow.svrha };
    }
    const row = this.tableRowContent[rowIndex] || [];
    const val = (key: string) => {
      const idx = this.bankColumnIndex(key);
      return idx > -1 ? (row[idx] || '').toString() : '';
    };
    return { opis1: val('bankOpis1'), opis2: val('bankOpis2'), opis3: '', svrha: val('bankSvrhaDoznake') };
  }

  private async reloadBankRules(): Promise<void> {
    const clientID = localStorage.getItem('userID');
    if (!clientID || !this.bankCompanyAccount) {
      this.bankRules = [];
      return;
    }
    try {
      this.bankRules = await this.bankRuleService.listForAccount(clientID, this.bankCompanyAccount, true);
    } catch (err) {
      console.error('[BankStatement] Loading posting rules failed:', err);
      this.bankRules = [];
    }
  }

  private loadBankManualFlags(invoice: any): void {
    try {
      const parsed = JSON.parse(invoice.extractedProductsResults || '{}');
      (parsed.items || []).forEach((item: any, i: number) => {
        if (item.bankManualKonto) this.rowBankManualKonto[i] = true;
        if (item.bankManualPartner) this.rowBankManualPartner[i] = true;
      });
    } catch { /* no stored rows yet */ }
  }

  /**
   * Suggest Konto / Sifra partnera from the rules of the company account. The
   * newest matching rule is applied to every cell the user did not set by
   * hand, so a value suggested by an older rule is replaced when a newer,
   * more specific rule matches. `forceRowIndex` (the row a rule was just
   * created from) is always overwritten.
   */
  private applyBankRulesToRows(forceRowIndex: number = -1): void {
    const kontoIdx = this.bankColumnIndex('bankKonto');
    const partnerIdx = this.bankColumnIndex('bankSifraPartnera');
    if (!this.bankRules.length || (kontoIdx < 0 && partnerIdx < 0)) return;

    this.tableRowContent.forEach((row: any[], i: number) => {
      const rule = BankPostingRuleService.findMatch(this.bankRules, this.bankRowValues(i));
      if (!rule) return;
      const force = i === forceRowIndex;
      if (kontoIdx > -1 && rule.konto && (force || !this.rowBankManualKonto[i])) {
        row[kontoIdx] = rule.konto;
        this.rowBankManualKonto[i] = false;
      }
      if (partnerIdx > -1 && rule.partnerCode && (force || !this.rowBankManualPartner[i])) {
        row[partnerIdx] = rule.partnerCode;
        this.rowBankManualPartner[i] = false;
      }
      this.refreshBankIdBroj(i);
    });
  }

  /** Typing or picking in a Konto / partner cell marks it as set by hand. */
  onBankKontoEdited(rowIndex: number): void {
    const idx = this.bankColumnIndex('bankKonto');
    this.rowBankManualKonto[rowIndex] = idx > -1 && !!(this.tableRowContent[rowIndex][idx] || '').toString().trim();
  }

  onBankPartnerEdited(rowIndex: number): void {
    const idx = this.bankColumnIndex('bankSifraPartnera');
    this.rowBankManualPartner[rowIndex] = idx > -1 && !!(this.tableRowContent[rowIndex][idx] || '').toString().trim();
    this.refreshBankIdBroj(rowIndex);
  }

  /** ID broj is always derived from the codebook entry of the partner code. */
  refreshBankIdBroj(rowIndex: number): void {
    const idIdx = this.bankColumnIndex('bankIdBroj');
    const partnerIdx = this.bankColumnIndex('bankSifraPartnera');
    if (idIdx < 0) return;
    const row = this.tableRowContent[rowIndex];
    if (!row) return;
    const code = partnerIdx > -1 ? (row[partnerIdx] || '').toString().trim() : '';
    const hit = code ? this.codebookItems.find((c) => c.code === code) : undefined;
    row[idIdx] = hit?.idNumber || '';
  }

  onBankKontoSelected(konto: string, rowIndex: number, colIndex: number): void {
    this.tableRowContent[rowIndex][colIndex] = konto;
    this.onBankKontoEdited(rowIndex);
  }

  onBankPartnerSelected(code: string, rowIndex: number, colIndex: number): void {
    this.tableRowContent[rowIndex][colIndex] = code;
    this.onBankPartnerEdited(rowIndex);
  }

  private bankDialogBaseData() {
    return {
      clientID: localStorage.getItem('userID') || '',
      companyAccount: this.bankCompanyAccount,
      chartOfAccounts: this.chartOfAccounts,
      codebookItems: this.codebookItems,
    };
  }

  /** Opis_1 click: create a posting rule pre-filled from that row. */
  openBankRuleDialog(rowIndex: number): void {
    if (!this.bankCompanyAccount) {
      this.snackBar.open('Company bank account not found in the statement XML; rules cannot be created', '', {
        duration: 5000,
        panelClass: ['white-snackbar'],
      });
      return;
    }
    const data: BankPostingRuleDialogData = {
      ...this.bankDialogBaseData(),
      row: this.bankRowValues(rowIndex),
    };
    this.dialog
      .open(BankPostingRuleDialogComponent, { data, autoFocus: false })
      .afterClosed()
      .subscribe(async (saved: BankPostingRule | undefined) => {
        if (!saved) return;
        await this.reloadBankRules();
        this.applyBankRulesToRows(rowIndex);
        this.snackBar.open('Rule saved and applied', '', { duration: 3000, panelClass: ['white-snackbar'] });
      });
  }

  /** "Pravila za stavke": manage the rules of the statement's company account. */
  openBankRulesListDialog(): void {
    if (!this.bankCompanyAccount) return;
    const data: BankPostingRulesListDialogData = this.bankDialogBaseData();
    this.dialog
      .open(BankPostingRulesListDialogComponent, { data, autoFocus: false })
      .afterClosed()
      .subscribe(async (changed: boolean) => {
        if (!changed) return;
        await this.reloadBankRules();
        this.applyBankRulesToRows();
      });
  }

  loadExistingCheckboxValues(invoice: any): void {
    if (!invoice.extractedProductsResults) return;
    
    try {
      const productsData = JSON.parse(invoice.extractedProductsResults);
      if (productsData.items && Array.isArray(productsData.items)) {
        productsData.items.forEach((item: any, index: number) => {
          if (item.useCash !== undefined) {
            this.rowUseCash[index] = item.useCash;
          }
          if (item.syncToEPO !== undefined) {
            this.rowSyncToEPO[index] = item.syncToEPO;
          }
        });
      }
    } catch (error) {
      console.error('Error loading existing checkbox values:', error);
    }
  }

  hasChanges(): boolean {
    const updatedProducts = {
      items: this.tableRowContent.map((row: any[]) => {
        const product: any = {};
        this.extractGoodsAndMaterialFields().forEach(
          (header: string, index: number) => {
            product[header] = row[index].trim();
          }
        );
        return product;
      }),
    };

    const currentExtractedProductsResults = JSON.stringify(
      updatedProducts,
      null,
      2
    );

    const hasChanges =
      currentExtractedProductsResults !==
      this.initialExtractedProductsResults ||
      this.currentInvoice.rotateAngle !== this.currentAngle % 360;

    return hasChanges;
  }

  /// Function to track rows by their index to prevent re-rendering
  trackByFn(index: number, item: any): number {
    return index;
  }

  toggleObjectValues(obj: any, value: boolean) {
    Object.keys(obj).forEach((key) => {
      obj[key] = value;
    });
  }

  isTemplateSelected() {
    if (this.template) return true;
    return false;
  }

  get templateId() {
    return this.template?.id;
  }

  isSpecificTemplateSelected(template: any) {
    return this.template?.id === template.id;
  }

  getSingularOrPlural(length: number) {
    return length > 1 ? 'racuna imaju' : 'racun ima';
  }

  async changeStep(value: any): Promise<void> {
    if (
      (this.imageIndex === this.data.duplicatedArray.length - 1 &&
        value === 'next') ||
      (this.imageIndex === 0 && value === 'previous')
    ) {
      return;
    }

    this.data.duplicatedArray[this.imageIndex].rotateAngle = this.currentAngle;

    let currentStep = this.data.duplicatedArray.find(
      (slide: any) => slide.index == this.imageIndex
    );

    this.prepareForEdit(this.imageIndex + (value === 'next' ? 1 : -1));

    currentStep = this.handleVatFieldUpdateInputs(currentStep);
    await this.updateCurrentInvoice(currentStep).then(() => {
      this.imageIndex += value === 'previous' ? -1 : 1;

      // Load TXT file content if applicable
      if (this.isTxtFile(this.data.duplicatedArray[this.imageIndex]?.name)) {
        this.loadTxtFileContent(this.data.duplicatedArray[this.imageIndex]);
      }

      setTimeout(() => {
        this.selectedInvoiceCopy = JSON.parse(
          JSON.stringify(this.data.duplicatedArray[this.imageIndex])
        );

        this.imageSrc =
          this.data.duplicatedArray[this.imageIndex]?.thumbnailPath;
        this.currentAngle = this.selectedInvoiceCopy.rotateAngle % 360 || 0;

        this.rotateImage(0);

        setTimeout(() => {
          this.onImageLoad();
        }, 0);
      }, 100);
    });
  }

  private async updateCurrentInvoice(currentStep: any) {
    if (
      JSON.stringify(currentStep?.inputs) !==
      JSON.stringify(this.selectedInvoiceCopy.inputs) ||
      currentStep.rotateAngle !== this.selectedInvoiceCopy.rotateAngle
    ) {
      const updatedInvoice = this.updateExtractedResults(currentStep);

      // Adding rotateAngle separately
      const updatedInvoiceWithRotateAngle = {
        ...updatedInvoice,
        rotateAngle: currentStep.rotateAngle,
      };

      this.data.duplicatedArray!.forEach((el: any, index: any) => {
        el.index = index;
      });

      console.log(
        'updateCurrentInvoice(): updatedInvoiceWithRotateAngle:' +
        JSON.stringify(updatedInvoiceWithRotateAngle, null, 2)
      );
      await this.invoiceService
        .UpdateInvoice(updatedInvoiceWithRotateAngle)
        .catch((err) => console.log(err));
    }
  }

  private updateExtractedResults(currentStep: any) {
    let refactoredExtractedResults: any = {};
    let missingFieldsValues: string[] = [];
    currentStep.inputs.forEach((input: any) => {
      if (this.vatFields.includes(input.heading)) return;
      if (input.value) {
        refactoredExtractedResults[input.heading] = input.value;
      } else {
        missingFieldsValues.push(input.heading);
      }
    });
    currentStep.inputs.forEach((input: any) => {
      if (
        (input.heading === 'deductibleTaxBase' ||
          input.heading === 'nonDeductibleTaxBase') &&
        input.value
      ) {
        refactoredExtractedResults['taxBase'] = input.value;
      } else if (
        (input.heading === 'deductibleVAT' ||
          input.heading === 'nonDeductibleVAT') &&
        input.value
      ) {
        refactoredExtractedResults['vat'] = input.value;
      }
    });

    currentStep.extractedResults = JSON.stringify(refactoredExtractedResults);
    currentStep.missingFields = missingFieldsValues;
    return {
      id: currentStep.id,
      extractedResults: currentStep.extractedResults,
      missingFields: JSON.stringify(missingFieldsValues),
    };
  }

  async skipAndDownload(action: string = 'details') {
    this.isLoadingButton = true;
    let currentStep = this.data.duplicatedArray.find(
      (slide: any) => slide.index == this.imageIndex
    );

    if (action === 'details') {
      currentStep = this.handleVatFieldUpdateInputs(currentStep);
      currentStep.rotateAngle = this.currentAngle;
      console.log(
        'skipAndDownload(): currentStep:' + JSON.stringify(currentStep, null, 2)
      );
      await this.updateCurrentInvoice(currentStep);
    }
    let selectedInvoices = Object.entries(this.vatIncludedCheckbox)
      .map(([key, value], index) =>
        value ? this.data.duplicatedArray[index].id : ''
      )
      .filter((el) => el !== '');

    if (this.isAllChecked) {
      selectedInvoices = this.listOfAllInvoicesIDs;
    }
    let input: {
      folderID: string;
      templateID: string;
      format: string;
      vatIncludedInvoiceIDs: string[];
      startingIndex?: number;
    } = {
      folderID: this.data.template.id,
      templateID: this.template.id,
      format: this.template.id === 'eLine' ? 'xml' : 'excel',
      vatIncludedInvoiceIDs: selectedInvoices,
    };
    if (this.startingIndex) {
      input['startingIndex'] = this.startingIndex;
    }
    let updatedExtractedResults: any[] = [];
    this.data.duplicatedArray.forEach((step: any) => {
      updatedExtractedResults.push(this.updateExtractedResults(step));
    });

    // Persist all invoice edits (including konto) to DB BEFORE triggering the
    // export, because the backend Lambda reads directly from the database.
    await Promise.all(
      updatedExtractedResults.map((payload) =>
        this.invoiceService
          .UpdateInvoice(payload)
          .catch((err) =>
            console.error('Failed to save invoice before export:', payload.id, err)
          )
      )
    );

    let areThereMissingAttributes = false;

    for (const element of this.data.duplicatedArray) {
      if (element.missingFields.some((field: any) => field !== '')) {
        areThereMissingAttributes = true;
        break;
      }
    }
    const updatedFolder = {
      id: this.data.duplicatedArray[0].folderID,
      areThereMissingFields: areThereMissingAttributes,
    };

    await this.folderService
      .UpdateFolder(updatedFolder)
      .then(async () => {
        await this.invoiceService
          .ExportFolderInvoices(input)
          .then((data) => {
            this.invoiceService.downloadExcelFile(data);
            this.isLoadingButton = false;
            setTimeout(() => {
              this.isClosed = true;
              this.dialogRef.close({ updatedExtractedResults });
            }, 300);
          })
          .catch((err) => {
            this.snackBar.open('Download failed, please try again', '', {
              duration: 5000,
              panelClass: ['white-snackbar'],
            });
            console.log(err);
          });
      })
      .catch((err) => {
        this.snackBar.open('Download failed, please try again', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        console.log(err);
      });
  }

  isErrorPresentOnCurrentInvoice(data: any) {
    const invoiceKeyValues: any[] = data.filter((input: any) =>
      this.tableHeaders.includes(input.heading)
    );
    for (let x = 0; x < invoiceKeyValues.length; x++) {
      const keyValuePair = invoiceKeyValues[x];
      // if value empty return missing true
      if (!keyValuePair?.value || keyValuePair.value === '') {
        // if is a vat field and substitute exists do not return missing true
        if (this.vatFields.includes(keyValuePair.heading)) {
          const substitute = invoiceKeyValues.find(
            (el: any) =>
              el.heading === this.vatSubstitutes[keyValuePair.heading]
          );
          if (substitute && substitute.value && substitute.value !== '') {
            continue;
          }
        }
        return true;
      }
    }
    return false;
  }

  openDocumentEmitter(event: any, eventName: any) {
    // if (event) {
    //   window.open(eventName)
    // }
  }

  doesRowHaveEmptyValues(value: any, i: number) {
    // logic changed from previous, kept as comment if needed
    // const {indexTaxBase, indexNonDeductibleTaxBase, indexVAT, indexNonDeductibleVAT} = this.checkWhichAttributeIsIncluded();
    // if (!this.isVatMissing && !this.isTaxBaseMissing) {
    //   return value.slice(4).some((el: any) => el.trim() === '');
    // }
    // else if (this.isVatMissing && !this.isTaxBaseMissing) {
    //   return value.slice(2).some((el: any) => el.trim() === '');
    // }
    // else if (this.isTaxBaseMissing && !this.isVatMissing) {
    //   return value.slice(2).some((el: any) => el.trim() === '');
    // }

    // console.log('this.data.duplicatedArray', this.data.duplicatedArray);

    const invoiceKeyValues: any[] = this.data.duplicatedArray[i]?.inputs.filter(
      (input: any) => this.tableHeaders.includes(input.heading)
    );
    let hasEmpty = false;
    for (let x = 0; x < invoiceKeyValues?.length; x++) {
      const keyValuePair = invoiceKeyValues[x];
      // skip otherExpenses from empty value check
      if (keyValuePair.heading === 'otherExpenses') continue;
      let isMissing = false;
      let skippedDueToSubstitute = false;
      // if value empty return missing true
      if (!keyValuePair?.value || keyValuePair.value === '') {
        isMissing = true;
        // if is a vat field and substitute exists do not return missing true
        if (this.vatFields.includes(keyValuePair.heading)) {
          const substitute = invoiceKeyValues.find(
            (el: any) =>
              el.heading === this.vatSubstitutes[keyValuePair.heading]
          );
          if (substitute && substitute.value && substitute.value !== '') {
            isMissing = false;
            skippedDueToSubstitute = true;
          }
        }
      }
    }
    return hasEmpty;
    // return value.some((el: any) => (el || '').trim() === '');
  }

  doesTableHaveEmptyValues() {
    let areEmptyFieldsPresent = false;
    this.tableRowContent.forEach((el) => {
      if (el.some((input: any) => (input || '').trim() === '')) {
        areEmptyFieldsPresent = true;
      }
    });
    return areEmptyFieldsPresent;
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.startingIndex = value !== '' ? parseFloat(value) : undefined;
  }

  onInputKeyDown(event: KeyboardEvent) {
    const enteredCharacter = event.key;
    // Block the negative sign key (KeyCode 189) from being entered
    if (
      enteredCharacter === 'Delete' ||
      enteredCharacter === 'Backspace' ||
      (enteredCharacter === 'a' && (event.ctrlKey || event.metaKey))
    ) {
      return;
    }

    // Block the input if it is not a digit
    if (!/^\d$/.test(enteredCharacter)) {
      event.preventDefault();
    }
  }

  private arraysEqual(a: Array<any>, b: Array<any>) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  private handleVatFieldUpdateInputs(currentStep: any) {
    const taxBase =
      currentStep?.inputs?.find((el: any) => el?.heading === 'taxBase') || {};
    const vat =
      currentStep?.inputs?.find((el: any) => el?.heading === 'vat') || {};
    let taxBaseValue = taxBase?.value || '';
    let vatValue = vat?.value || '';

    currentStep?.inputs?.forEach((el: any) => {
      if (
        (el?.heading === 'deductibleTaxBase' ||
          el?.heading === 'nonDeductibleTaxBase') &&
        el?.value &&
        el?.value !== ''
      ) {
        taxBaseValue = el?.value;
      }
      if (
        (el?.heading === 'deductibleVAT' ||
          el?.heading === 'nonDeductibleVAT') &&
        el?.value &&
        el?.value !== ''
      ) {
        vatValue = el?.value;
      }
    });

    taxBase.value = taxBaseValue;
    vat.value = vatValue;
    return currentStep;
  }

  private prepareForEdit(index: number) {
    if (!this.tableRowContent[index]) {
      return;
    }

    // put vat fields to the rendered array row
    this.data.duplicatedArray[index].inputs.forEach((el: any) => {
      if (!el || el.value === '') {
        const headingIndex = this.tableHeaders.findIndex(
          (a) => a === el.heading
        );

        if (headingIndex === -1) {
          return;
        }

        if (!this.tableRowContent[index][headingIndex]) {
          return;
        }

        el.value = this.tableRowContent[index][headingIndex];
      }
    });

    // add appropriate vat fields with checkbox checked status
    if (this.vatIncludedCheckbox[index]) {
      this.data.duplicatedArray[index].inputs = this.data.duplicatedArray[
        index
      ].inputs.filter((el: any) => {
        if (
          el.heading !== 'nonDeductibleVAT' &&
          el.heading !== 'nonDeductibleTaxBase'
        ) {
          return true;
        } else if (this.tableHeaders.includes(el.heading)) {
          return true;
        }
        return false;
      });
    } else {
      this.data.duplicatedArray[index].inputs = this.data.duplicatedArray[
        index
      ].inputs.filter((el: any) => {
        if (
          el.heading !== 'deductibleVAT' &&
          el.heading !== 'deductibleTaxBase'
        ) {
          return true;
        } else if (this.tableHeaders.includes(el.heading)) {
          return true;
        }
        return false;
      });
    }

    if (this.vatIncludedCheckbox[index]) {
      if (
        this.data.duplicatedArray[index].inputs.findIndex(
          (el: any) => el.heading === 'deductibleTaxBase'
        ) >= 0
      ) {
        this.data.duplicatedArray[index].inputs = this.data.duplicatedArray[
          index
        ].inputs.filter((el: any) => el.heading !== 'nonDeductibleTaxBase');
      }
      if (
        this.data.duplicatedArray[index].inputs.findIndex(
          (el: any) => el.heading === 'deductibleVAT'
        ) >= 0
      ) {
        this.data.duplicatedArray[index].inputs = this.data.duplicatedArray[
          index
        ].inputs.filter((el: any) => el.heading !== 'nonDeductibleVAT');
      }
    } else {
      if (
        this.data.duplicatedArray[index].inputs.findIndex(
          (el: any) => el.heading === 'nonDeductibleTaxBase'
        ) >= 0
      ) {
        this.data.duplicatedArray[index].inputs = this.data.duplicatedArray[
          index
        ].inputs.filter((el: any) => el.heading !== 'deductibleTaxBase');
      }
      if (
        this.data.duplicatedArray[index].inputs.findIndex(
          (el: any) => el.heading === 'nonDeductibleVAT'
        ) >= 0
      ) {
        this.data.duplicatedArray[index].inputs = this.data.duplicatedArray[
          index
        ].inputs.filter((el: any) => el.heading !== 'deductibleVAT');
      }
    }

    this.data.duplicatedArray[index].inputs = this.sortByHeadings(
      this.data.duplicatedArray[index].inputs,
      this.tableHeaders
    );
  }

  private sortByHeadings(
    dataArray: EditInput[],
    headingOrder: string[]
  ): EditInput[] {
    const headingIndex: Record<string, number> = {};

    headingOrder.forEach((heading, index) => {
      headingIndex[heading] = index;
    });

    dataArray.sort((a, b) => {
      const indexA = headingIndex[a.heading];
      const indexB = headingIndex[b.heading];

      // Handle cases where heading is not found in headingOrder
      if (indexA === undefined && indexB === undefined) {
        return 0;
      } else if (indexA === undefined) {
        return 1;
      } else if (indexB === undefined) {
        return -1;
      }

      return indexA - indexB;
    });

    return dataArray;
  }

  checkRowStatus(row: any) {
    if (row.length) {
      return true;
    } else {
      return false;
    }
  }

  async unassignUser(assignmentId: string) {
    try {
      await this.invoicesService.removeInvoiceAssignment([assignmentId]);
      // Update the assignments list in the current document
      const currentDoc = this.data.duplicatedArray[this.imageIndex];
      if (currentDoc.invoiceUserAssignments?.items) {
        currentDoc.invoiceUserAssignments.items = currentDoc.invoiceUserAssignments.items
          .filter((assignment: InvoiceUserAssignment) => assignment.id !== assignmentId);
      }
    } catch (error) {
      console.error('Error removing assignment:', error);
    }
  }

  get isBbiBamEbFolder(): boolean {
    const name = this.folder?.name || '';
    return name.includes('BBI BAM EB');
  }

  get isAsaFolder(): boolean {
    const name = this.folder?.name || '';
    return !!(name.includes('ASA') || name.includes('HALCOM') || name.includes('PROCREDIT') || name.includes('BBI') || name.includes('RB') || name.includes('RAIFFEISEN') || name.includes('ASA BAM') || name.includes('ASA EUR') || name.includes('ZIRAAT') || name.includes('MF BAM') || name.includes('MF EUR') || name.includes('UNICREDIT BAM') || name.includes('UNICREDIT EUR') || name.includes('NLB') || name.includes('SPARKASSE') || name.includes('ADDIKO') || name.includes('NOVA BAM') || name.includes('NOVA EUR') || name.includes('PBS') || name.includes('PBS1') || name.includes('INTESA') || name.includes('UNION BAM') || name.includes('KIB'));
  }

  get txtFolderLabel(): string {
    const name = this.folder?.name || '';
    if (name.includes('PROCREDIT')) return 'PROCREDIT+5D';
    if (name.includes('BBI')) return 'BBI+5D';
    if (name.includes('RAIFFEISEN')) return 'RAIFFEISEN+5D';
    if (name.includes('ASA EUR')) return 'ASA EUR+5D';
    if (name.includes('ASA BAM')) return 'ASA BAM+5D';
    if (name.includes('ZIRAAT')) return 'ZIRAAT+5D';
    if (name.includes('MF BAM')) return 'MF BAM+5D';
    if (name.includes('MF EUR')) return 'MF EUR+5D';
    if (name.includes('UNICREDIT BAM')) return 'UNICREDIT BAM+5D';
    if (name.includes('UNICREDIT EUR')) return 'UNICREDIT EUR+5D';
    if (name.includes('NLB')) return 'NLB+5D';
    if (name.includes('SPARKASSE')) return 'SPARKASSE+5D';
    if (name.includes('ADDIKO')) return 'ADDIKO+5D';
    if (name.includes('NOVA BAM')) return 'NOVA BAM+5D';
    if (name.includes('NOVA EUR')) return 'NOVA EUR+5D';
    if (name.includes('PBS')) return 'PBS+5D';
    if (name.includes('PBS1')) return 'PBS1+5D';
    if (name.includes('INTESA')) return 'INTESA+5D';
    if (name.includes('UNION BAM')) return 'UNION BAM+5D';
    if (name.includes('HALCOM')) return 'HALCOM+5D';
    if (name.includes('KIB')) return 'KIB+5D';
    if (name.includes('RB')) return 'RB+5D';

    return 'ASA BANKA+5D';
  }

  onTemplateTypeChange(type: 'excel' | 'xml' | 'txt') {
    this.selectedTemplateFormat = type;
    this.selectedTemplate = '';
    if (type === 'txt') {
      this.loadTxtInvoicesList();
      this.loadXmlAttributeTemplates();
    } else if (type === 'xml' && this.isBbiBamEbFolder) {
      this.loadXmlInvoicesList();
    } else {
      this.getTemplates();
    }
  }

  async loadXmlInvoicesList(): Promise<void> {
    this.isXmlInvoicesLoading = true;
    this.xmlInvoicesList = [];
    this.selectedXmlMap = {};
    try {
      let invoices: any[] = this.data.duplicatedArray || [];
      if (!invoices.length && this.folderID) {
        const folderData: any = await this.invoiceService.GetFolder(this.folderID, 200);
        invoices = folderData?.invoices?.items || [];
      }
      this.xmlInvoicesList = invoices.filter((inv: any) => {
        const name: string = (inv?.name || '').toLowerCase();
        return name.endsWith('.pdf') || name.includes('/invoices/') || name.includes('/user-data/');
      });
      if (this.xmlInvoicesList.length === 1) {
        this.selectedXmlMap[this.xmlInvoicesList[0].id] = true;
      }
    } catch (err) {
      console.error('[BbiBamEbXml] Error loading invoices:', err);
    } finally {
      this.isXmlInvoicesLoading = false;
    }
  }

  toggleXmlInvoiceSelection(invoice: any): void {
    this.selectedXmlMap[invoice.id] = !this.selectedXmlMap[invoice.id];
  }

  isXmlInvoiceSelected(invoice: any): boolean {
    return !!this.selectedXmlMap[invoice.id];
  }

  hasSelectedXmlInvoices(): boolean {
    return Object.values(this.selectedXmlMap).some(v => v);
  }

  getInvoiceDisplayName(invoice: any): string {
    const raw: string = invoice?.title || invoice?.name || '';
    const parts = raw.split('/');
    return parts[parts.length - 1] || raw;
  }

  async downloadBbiBamEbXml(): Promise<void> {
    this.isLoadingButton = true;
    try {
      const selected = this.xmlInvoicesList.filter(inv => this.selectedXmlMap[inv.id]);
      if (!selected.length) {
        this.snackBar.open('Please select at least one file to download', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
        this.isLoadingButton = false;
        return;
      }

      for (const invoice of selected) {
        const xmlKey = `public/bankStatements/${invoice.id}.xml`;
        const signedUrl = await Storage.get(xmlKey, {
          customPrefix: { public: '' },
          level: 'public',
          download: false,
          expires: 300,
        });

        const blob = await this.http
          .get(signedUrl as string, { responseType: 'blob' })
          .toPromise();
        const blobUrl = URL.createObjectURL(blob!);
        const displayName = this.getInvoiceDisplayName(invoice);
        const filename = displayName.replace(/\.pdf$/i, '') + '.xml';

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }

      this.snackBar.open(
        `Downloaded ${selected.length} XML file${selected.length > 1 ? 's' : ''}`,
        '',
        { duration: 3000, panelClass: ['white-snackbar'] }
      );
      setTimeout(() => {
        this.isClosed = true;
        this.dialogRef.close();
      }, 300);
    } catch (err) {
      console.error('[BbiBamEbXml] Download error:', err);
      this.snackBar.open('Download failed, please try again', '', {
        duration: 5000,
        panelClass: ['white-snackbar'],
      });
    } finally {
      this.isLoadingButton = false;
    }
  }

  async loadTxtInvoicesList(): Promise<void> {
    this.isTxtInvoicesLoading = true;
    this.txtInvoicesList = [];
    this.selectedTxtMap = {};
    try {
      let invoices: any[] = this.data.duplicatedArray || [];
      if (!invoices.length && this.folderID) {
        const folderData: any = await this.invoiceService.GetFolder(this.folderID, 200);
        invoices = folderData?.invoices?.items || [];
      }
      this.txtInvoicesList = invoices.filter((inv: any) =>
        inv?.name?.toLowerCase().endsWith('.txt')
      );
      if (this.txtInvoicesList.length === 1) {
        this.selectedTxtMap[this.txtInvoicesList[0].id] = true;
      }
    } catch (err) {
      console.error('[ASA Bank TXT] Error loading TXT invoices:', err);
    } finally {
      this.isTxtInvoicesLoading = false;
    }
  }

  toggleTxtInvoiceSelection(invoice: any): void {
    this.selectedTxtMap[invoice.id] = !this.selectedTxtMap[invoice.id];
  }

  isTxtInvoiceSelected(invoice: any): boolean {
    return !!this.selectedTxtMap[invoice.id];
  }

  hasSelectedTxtInvoices(): boolean {
    return Object.values(this.selectedTxtMap).some(v => v);
  }

  async downloadAsaBankaTxt(): Promise<void> {
    this.isLoadingButton = true;
    try {
      const txtInvoices = this.txtInvoicesList.filter(inv =>
        this.selectedTxtMap[inv.id]
      );

      if (!txtInvoices.length) {
        this.snackBar.open('Please select at least one TXT file to download', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
        this.isLoadingButton = false;
        return;
      }

      for (const invoice of txtInvoices) {
        let s3Key = invoice.name;
        if (invoice.name.startsWith('https://') || invoice.name.startsWith('http://')) {
          const urlMatch = invoice.name.match(/https?:\/\/[^\/]+\/(.+)/);
          if (urlMatch?.[1]) {
            s3Key = urlMatch[1];
          }
        }

        const signedUrl = await Storage.get(s3Key, {
          customPrefix: { public: '' },
          level: 'public',
          download: false,
          expires: 300,
        });

        const blob = await this.http
          .get(signedUrl as string, { responseType: 'blob' })
          .toPromise();
        const blobUrl = URL.createObjectURL(blob!);
        const filename = s3Key.split('/').pop() || `${invoice.id}.txt`;

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }

      this.snackBar.open(
        `Downloaded ${txtInvoices.length} TXT file${txtInvoices.length > 1 ? 's' : ''}`,
        '',
        { duration: 3000, panelClass: ['white-snackbar'] }
      );
      setTimeout(() => {
        this.isClosed = true;
        this.dialogRef.close();
      }, 300);
    } catch (err) {
      console.error('[ASA Bank TXT] Download error:', err);
      this.snackBar.open('Download failed, please try again', '', {
        duration: 5000,
        panelClass: ['white-snackbar'],
      });
    } finally {
      this.isLoadingButton = false;
    }
  }

  async downloadAsaBankaTxtAsXml(): Promise<void> {
    this.isLoadingButton = true;
    try {
      const selected = this.txtInvoicesList.filter(inv => this.selectedTxtMap[inv.id]);
      if (!selected.length) {
        this.snackBar.open('Please select at least one file to download', '', {
          duration: 3000,
          panelClass: ['white-snackbar'],
        });
        this.isLoadingButton = false;
        return;
      }

      const attrNames = this.bankXmlAttributeNames();
      if (attrNames.reserved.length) {
        this.snackBar.open(
          `"${attrNames.reserved.join('", "')}" already exist in the bank XML and cannot be used for Konto / ID broj / Sifra partnera. Change the name in the template.`,
          '',
          { duration: 8000, panelClass: ['white-snackbar'] }
        );
        this.isLoadingButton = false;
        return;
      }
      if (attrNames.usedFallback) {
        this.snackBar.open(
          'No template defines XML attribute names for Konto / ID broj / Sifra partnera; using KONTO, IDBROJ and SIFRA_PARTNERA',
          '',
          { duration: 6000, panelClass: ['white-snackbar'] }
        );
      }
      if (this.codebookItems.length === 0) {
        await this.loadCodebookItems();
      }

      for (const invoice of selected) {
        const raw = await this.bankXmlService.fetchRaw(invoice.id);
        // Add the Konto / ID broj / Sifra partnera the user assigned in the
        // Goods & Material preview to every <PR> row of the original file.
        const patched = BankStatementXmlService.patch(raw, this.bankXmlPatches(invoice, attrNames.names));
        const blob = new Blob([patched], { type: 'text/xml;charset=utf-8' });
        const blobUrl = URL.createObjectURL(blob);
        const displayName = this.getInvoiceDisplayName(invoice);
        const filename = (displayName.replace(/\.txt$/i, '') || invoice.id) + '.xml';

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }

      this.snackBar.open(
        `Downloaded ${selected.length} XML file${selected.length > 1 ? 's' : ''}`,
        '',
        { duration: 3000, panelClass: ['white-snackbar'] }
      );
      setTimeout(() => {
        this.isClosed = true;
        this.dialogRef.close();
      }, 300);
    } catch (err) {
      console.error('[BankXML] Download error:', err);
      this.snackBar.open('Download failed, please try again', '', {
        duration: 5000,
        panelClass: ['white-snackbar'],
      });
    } finally {
      this.isLoadingButton = false;
    }
  }

  // ─── XML attribute names for the izvod values ─────────────────────────────
  // Like every other template key, the user types the output name of
  // `Konto linije – izvod`, `ID broj – izvod` and `Sifra partnera – izvod` in
  // the template editor; that name becomes the XML attribute on download.

  /** Goods templates that configure at least one of the three izvod keys. */
  xmlAttributeTemplates: { id: string; name: string; template: any }[] = [];

  private async loadXmlAttributeTemplates(): Promise<void> {
    const userId = localStorage.getItem('userID');
    if (!userId) return;
    try {
      const response = await this.templateService2.ListTemplatesByClientIDProductsEnabledPK(
        `${userId}#TRUE`, undefined, undefined, undefined, 100
      );
      this.xmlAttributeTemplates = (response?.items || [])
        .map((el: any) => {
          let template: any = {};
          try { template = typeof el.template === 'string' ? JSON.parse(el.template) : el.template || {}; } catch { template = {}; }
          return { id: el.id, name: el.name, template };
        })
        .filter((t) => BANK_STATEMENT_XML_FIELDS.some((key) => !!t.template[key]));
      if (!this.xmlAttributeTemplates.some((t) => t.id === this.xmlAttributeTemplateId)) {
        this.xmlAttributeTemplateId = this.xmlAttributeTemplates[0]?.id || '';
      }
    } catch (err) {
      console.error('[BankXML] Could not load templates for attribute names:', err);
    }
  }

  /** Turn a configured title into a valid XML attribute name ("Konto linije" → "Konto_linije"). */
  private static toXmlAttributeName(title: string): string {
    let name = (title || '').trim().replace(/[^A-Za-z0-9_.-]+/g, '_').replace(/^_+|_+$/g, '');
    if (/^[^A-Za-z_]/.test(name)) name = '_' + name;
    return name;
  }

  private bankXmlAttributeNames(): { names: { [key: string]: string }; usedFallback: boolean; reserved: string[] } {
    const tpl = this.xmlAttributeTemplates.find((t) => t.id === this.xmlAttributeTemplateId);
    const names: { [key: string]: string } = {};
    const reserved: string[] = [];
    let usedFallback = false;
    for (const key of BANK_STATEMENT_XML_FIELDS) {
      const title = (tpl?.template?.[key] || '').toString().trim();
      // The default label is what the editor fills in when the user leaves the
      // name empty; it is not a configured attribute name.
      const configured = title && title !== BANK_STATEMENT_FIELD_LABELS[key]
        ? TemplateRunDialogComponent.toXmlAttributeName(title)
        : '';
      if (configured && BankStatementXmlService.isReservedAttributeName(configured)) {
        reserved.push(configured);
      }
      if (configured && BankStatementXmlService.isValidAttributeName(configured)) {
        names[key] = configured;
      } else {
        names[key] = BANK_STATEMENT_XML_FALLBACK_ATTRS[key];
        usedFallback = true;
      }
    }
    return { names, usedFallback, reserved };
  }

  /**
   * Per <PR> attributes from the rows saved in the Goods & Material preview.
   * Rows and PR elements come from the same TXT in the same order, so row i
   * is RED_BR i+1. Empty values are left out of the XML.
   */
  private bankXmlPatches(invoice: any, attrNames: { [key: string]: string }): BankStatementXmlPatch {
    const patches: BankStatementXmlPatch = {};
    let items: any[] = [];
    try {
      const raw = invoice?.extractedProductsResults;
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      items = Array.isArray(parsed?.items) ? parsed.items : [];
    } catch {
      items = [];
    }
    items.forEach((item: any, i: number) => {
      const partnerCode = (item?.bankSifraPartnera || '').toString().trim();
      let idBroj = (item?.bankIdBroj || '').toString().trim();
      if (!idBroj && partnerCode) {
        idBroj = this.codebookItems.find((c) => c.code === partnerCode)?.idNumber || '';
      }
      const values: { [key: string]: string } = {
        bankKonto: (item?.bankKonto || '').toString().trim(),
        bankIdBroj: idBroj,
        bankSifraPartnera: partnerCode,
      };
      const attrs: { [attr: string]: string } = {};
      for (const key of BANK_STATEMENT_XML_FIELDS) {
        if (values[key]) attrs[attrNames[key]] = values[key];
      }
      if (Object.keys(attrs).length) patches[String(i + 1)] = attrs;
    });
    return patches;
  }

  async sendToYourBooks() {
    this.isLoadingButton = true;
    
    try {
      const templateID = this.template?.id;
      const userID = localStorage.getItem('userID');
      
      // Determine which invoices to send
      let invoicesToSend: any[] = [];
      let invoiceIDs: string[] = [];
      
      if (this.isDownloadPreview) {
        // Single invoice preview mode - only send the current invoice
        const currentInvoice = this.data.duplicatedArray[this.imageIndex];
        if (currentInvoice?.id) {
          invoicesToSend = [currentInvoice];
          invoiceIDs = [currentInvoice.id];
        }
      } else {
        // Multi-invoice mode - send all invoices
        invoicesToSend = this.data.duplicatedArray || [];
        invoiceIDs = invoicesToSend
          .map((inv: any) => inv?.id)
          .filter((id: string) => !!id);
      }
      
      if (!invoiceIDs.length || !templateID || !userID) {
        this.snackBar.open('Missing invoice(s), template, or user information', '', {
          duration: 5000,
          panelClass: ['white-snackbar'],
        });
        this.isLoadingButton = false;
        return;
      }

      // Save modified invoice data to DynamoDB before triggering report
      for (const step of invoicesToSend) {
        const updatedInvoice: any = this.updateExtractedResults(step);
        // Also include extractedProductsResults (goods and materials data) if present
        if (step.extractedProductsResults) {
          updatedInvoice.extractedProductsResults = step.extractedProductsResults;
        }
        await this.invoiceService
          .UpdateInvoice(updatedInvoice)
          .catch((err: any) => console.log('Failed to update invoice:', err));
      }

      const response = await this.http.post<any>(
        environment.cicReportTriggerUrl,
        { invoiceIDs, templateID, userID }
      ).toPromise();

      if (response?.success && response?.jobId) {
        // Poll for job completion
        await this.pollCICReportStatus(response.jobId);
      } else {
        throw new Error(response?.error || 'Failed to process report');
      }
    } catch (error: any) {
      console.error('Send to Your Books error:', error);
      this.snackBar.open(error.message || 'Failed to send to Your Books. Please try again.', '', {
        duration: 5000,
        panelClass: ['white-snackbar'],
      });
      this.isLoadingButton = false;
    }
  }

  /**
   * Resolve the POS izvodi source file to a signed S3 URL.
   *
   * invoice.name can be a full S3 URL or a storage key. We extract the key,
   * request a presigned URL, and fall back to the original name if the lookup
   * fails.
   */
  private async getPosIzvodFileUrl(invoice: any): Promise<string> {
    if (!invoice?.name) return '';

    let s3Key = invoice.name;
    if (s3Key.startsWith('https://') || s3Key.startsWith('http://')) {
      const urlMatch = s3Key.match(/https?:\/\/[^\/]+\/(.+)/);
      if (urlMatch && urlMatch[1]) {
        s3Key = urlMatch[1];
      }
    }

    try {
      const signedUrl = await Storage.get(s3Key, {
        customPrefix: { public: '' },
        level: 'public',
        download: false,
        expires: 300,
      });
      return (signedUrl as string) || '';
    } catch (err) {
      console.error('Failed to get POS izvodi signed URL, using invoice.name:', err);
      return invoice.name;
    }
  }

  /**
   * Process a POS izvodi (card transaction notification) PDF or XLSX file.
   *
   * The file must have been uploaded through the normal invoice upload flow
   * (it exists in S3 and has an invoice record). This method sends the file's
   * S3 URL to the CIC report trigger Lambda with operation PROCESS_POS_IZVOD,
   * which parses it and generates the FINAL accounting Excel (3 rows per
   * transaction: konto 2051/2388/5537).
   */
  async processPosIzvod() {
    this.isLoadingButton = true;

    try {
      const userID = localStorage.getItem('userID');

      // Determine which invoice(s) to process
      let invoicesToProcess: any[] = [];

      if (this.isDownloadPreview) {
        const currentInvoice = this.data.duplicatedArray[this.imageIndex];
        if (currentInvoice?.id) {
          invoicesToProcess = [currentInvoice];
        }
      } else {
        invoicesToProcess = this.data.duplicatedArray.filter(
          (inv: any) => inv?.id
        );
      }

      if (!invoicesToProcess.length) {
        throw new Error('No file selected to process');
      }

      // Resolve signed S3 URLs for all selected POS files
      const fileUrls: string[] = [];
      const invoiceIDs: string[] = [];

      for (const invoice of invoicesToProcess) {
        const fileUrl = await this.getPosIzvodFileUrl(invoice);
        if (fileUrl) {
          fileUrls.push(fileUrl);
          invoiceIDs.push(invoice.id);
        } else {
          console.warn('Skipping invoice without a file URL:', invoice?.id);
        }
      }

      if (!fileUrls.length) {
        throw new Error('No valid POS izvodi files to process');
      }

      console.log('Processing POS izvodi files:', fileUrls);

      // Send all files in one job so the backend produces a single combined Excel
      const response = await this.http.post<any>(
        environment.cicReportTriggerUrl,
        {
          operation: 'PROCESS_POS_IZVOD',
          payload: {
            userID,
            fileUrls,
            invoiceIDs,
          },
        }
      ).toPromise();

      if (response?.success && response?.jobId) {
        await this.pollCICReportStatus(response.jobId);
      } else {
        throw new Error(response?.error || 'Failed to process POS izvodi');
      }
    } catch (error: any) {
      console.error('Process POS Izvodi error:', error);
      this.snackBar.open(
        error.message || 'Failed to process POS izvodi. Please try again.',
        '',
        { duration: 5000, panelClass: ['white-snackbar'] }
      );
      this.isLoadingButton = false;
    }
  }

  private async pollCICReportStatus(jobId: string, maxAttempts = 120, intervalMs = 5000): Promise<void> {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      try {
        const status = await this.http.get<any>(
          `${environment.cicReportStatusUrl}?jobId=${jobId}`
        ).toPromise();

        if (status?.status === 'COMPLETED') {
          const fileUrl = status?.excelFileUrl;
          if (fileUrl) {
            // Download the generated Excel file
            window.open(fileUrl, '_blank');
            this.snackBar.open('POS izvodi processed! File download started.', '', {
              duration: 7000,
              panelClass: ['white-snackbar'],
            });
          } else {
            this.snackBar.open('Successfully sent to Your Books!', '', {
              duration: 5000,
              panelClass: ['white-snackbar'],
            });
          }
          this.isLoadingButton = false;
          return;
        } else if (status?.status === 'FAILED') {
          throw new Error(status?.errorMessage || 'Report processing failed');
        }
        
        // Wait before next poll
        await new Promise(resolve => setTimeout(resolve, intervalMs));
      } catch (error: any) {
        if (error?.status === 404) {
          // Job not found yet, keep polling
          await new Promise(resolve => setTimeout(resolve, intervalMs));
          continue;
        }
        throw error;
      }
    }
    
    // Timeout - still show success as job is processing
    this.snackBar.open('Report is being processed. Check Your Books shortly.', '', {
      duration: 5000,
      panelClass: ['white-snackbar'],
    });
    this.isLoadingButton = false;
  }
}

type EditInput = {
  value: string;
  heading: string;
};
